{
    "headerData1": "MyHelp",
    "headerData2": "Az AI-segítőd az IT-ügyekhez",
    "headerMessage": "Használd a <span class='me8eon'>MyHelp</span>-et, ha IT-gondod van: kapsz lépésről lépésre útmutatókat, és segítünk eljutni a megfelelő IT-támogatási csatornához.",
    "loginLable": "Jelentkezz be",
    "logOff": "Jelentkezz ki",
    "logIn": "Jelentkezz be",
    "userName": "Profilnév",
    "switchLanguage": "Válts nyelvet",
    "switchRole": "Válts szerepet",
    "new": "ÚJ",
    "whatsnew": "Nézd meg, mi újság",
    "whatsnewtt": "Tudd meg, mi újság a MyHelp-ben",
    "organiseTiles": "Rendezd a csempéket",
    "confirm": "Erősítsd meg",
    "cancel": "Mégse",
    "close": "Zárd be",
    "reset": "Állítsd vissza",
    "continue_Tour": "Folytasd a túrát",
    "skip_Tour": "Hagyd ki a túrát",
    "save": "Mentsd el",
    "submit": "Küldd el",
    "delete": "Töröld",
    "trash_bin": "Dobd a kukába",
    "edit": "Szerkeszd meg",
    "yes": "Igen",
    "no": "Nem",
    "feedbackWidget": "Visszajelzésed",
    "itSupportPrompt": "IT-támogatásra van szükségem",
    "redirectingToITSupportAgent": "Átirányítás az IT-támogatási ügynökhöz",
    "restoredWidgetNotice": "Egy korábbi beszélgetésből. A műveletek ki vannak kapcsolva; kérdezz újra egy új kérés indításához.",
    "myITsupport": "Saját IT-támogatás",
    "shareViaOutlook": "Megosztás Outlookon keresztül",
    "registerLable": "A regisztrációhoz ",
    "underDevelopmentMsg": "Ez az oldal még készül",
    "apiFailDefaultMsg": "Hoppá, valami hiba történt. Próbáld meg később.",
    "more": "Még több",
    "searchResult": "Találatok",
    "showAll": "Mutasd az összeset",
    "showRelevant": "Mutasd a relevánsakat",
    "assistantTabTooltip": "Az Assistance valós időben átnézi az E.ON belső forrásait, hogy megválaszolja a kérdéseidet. Világos, könnyen érthető válaszokat ad forrásokkal együtt, így nyugodtan megbízhatsz az infóban",
    "searchTabTooltip": "Az E.ON Search egy sima kereső, ami segít gyorsan megtalálni az infót különböző E.ON forrásokból és a saját adataidból. A legrelevánsabb találatokat és a forrásokhoz vezető linkeket mutatja",
    "landingPage": {
        "hello": "Szia!",
        "title": "Miben segíthetek neked?",
        "searchApps": "Appok",
        "suggestions": "Tippek"
    },
    "footer": {
        "imprint": "Impresszum",
        "privacyPolicy": "Adatvédelem",
        "termsofUse": "Használati feltételek",
        "contact": "Írj nekünk",
        "PKI": "PKI",
        "privacySettings": "Adatvédelmi beállításaid",
        "aboutMe8EON": "A MyHelp-ről",
        "copyrights": "Szerzői jogok"
    },
    "tilePage": {
        "backToSearch": "Menj vissza az előző oldalra",
        "myInboxCountSuffix": "Függőben"
    },
    "myApprovalDataTable": {
        "FilterLable": {
            "all": "Mind",
            "leaveApptoval": "Szabi jóváhagyás",
            "timeSheet": "Munkaidőlap",
            "claim": "Igénylés",
            "serviceRequest": "Szolgáltatáskérés"
        },
        "tableData": {
            "approve": "Jóváhagy",
            "reject": "Elutasít",
            "requestId": "Kérés azonosítója",
            "description": "Leírás",
            "requestedBy": "Ki kérte",
            "requestedType": "Kérés típusa",
            "requestedDate": "Kérés dátuma",
            "status": "Státusz"
        }
    },
    "appData": {
        "time": "Időkövetés",
        "meeting": "Tárgyalóterem foglalás",
        "approval": "Jóváhagyásaim",
        "pr": "Beszerzési igény létrehozása",
        "pra": "Beszerzési igény létrehozása (haladó)",
        "processing": "Beérkező leveleim",
        "hr": "HR Portal",
        "hrLabel": "HR Portal",
        "concur": "Concur Utazási foglalások és költségek",
        "password": "SAP jelszó visszaállítása",
        "ariba": "Ariba - Klasszikus és Klasszikus+",
        "itresources": "IT erőforrások",
        "myassets": "Eszközeim",
        "order": "Rendelés",
        "incident": "Események",
        "beeline": "Beeline",
        "prisma": "Prisma",
        "gertrud": "Gertrud",
        "notification": "Értesítési Portal",
        "zuko": "Zuko",
        "eon_brand": "EON Márkaterület",
        "pki": "PKI Portal",
        "mail": "Mail DL",
        "journey": "Utazások/Események",
        "mygenius": "MyGenius",
        "ideeon": "idEE.ON",
        "ideenet": "IdeeNet",
        "dpf": "Személyi akták - Digitális személyi akták - DPF",
        "corpsac": "Vállalati SAC",
        "corpportal": "Vállalati Portal",
        "redwood": "Redwood Pénzügyi Automatizálás",
        "eamsap200": "EAM (200)",
        "eamsap100": "EAM (100)",
        "sodsap": "SoD SAP Portal",
        "videon": "VidE.ON",
        "alteryx": "Alteryx",
        "ebam": "Banki: Bank Számlakezelés (EBAM)",
        "egs": "E.ON Garancia Megoldás",
        "epsnext": "EPSnext",
        "fisquantum": "FIS Quantum",
        "rms": "RMS - Kockázatkezelés",
        "slido": "Slido",
        "insightslibrary": "Insights Könyvtár",
        "getabstract": "getAbstract",
        "mypotential": "Saját potenciálom elérése",
        "dsesoftware": "DSE Szoftver",
        "whistleblowing": "E.ON Whistleblowing Megoldás",
        "maqsima": "MAQSIMA TMS",
        "digitalrulebook": "Paula Policy",
        "oneERP": "OneERP",
        "Perseus": "Incidens jelentés",
        "cateringportal": "Étlap",
        "westnetzregelwerke": "Westnetz Szabályzatok",
        "werbemittel": "Reklámanyagok",
        "westenergie_brand": "Márkamenedzsment Portal",
        "compass": "Compass",
        "gradar": "Gradar",
        "beqom": "beqom",
        "kyc": "KYC",
        "talentry": "Talentry",
        "sam": "SAM",
        "enorm": "e-NORM",
        "redonline": "ROL",
        "tagetikcpm": "Tagetik CPM",
        "tagetikcpmerm": "Tagetik CPM és ERM",
        "smartguide": "Smart Guide",
        "tagetiksac": "Tagetik SAC",
        "myit": "my IT",
        "timehover": "A CATS-szel könnyen nyomon követheted és kezelheted a munkaóráidat és tevékenységeidet – minden fontos infó és funkció egy helyen.",
        "meetinghover": "A Gingco, a tárgyalófoglaló eszközünk segít, hogy egyszerűen kezeld és ütemezd a tárgyalókat és az erőforrásokat – hatékony kihasználással, egy helyen.",
        "approvalhover": "A myInboxban gyorsan és egyszerűen jóváhagyhatod a számlákat – minden releváns infó és művelet egy helyen.",
        "prhover": "Itt mindent megtalálsz áruk és szolgáltatások igényléséhez. Németül BANF néven is ismert (beszerzési igény).",
        "prahover": "Itt mindent megtalálsz áruk és szolgáltatások igényléséhez. Németül BANF néven is ismert (beszerzési igény).",
        "processinghover": "A myInboxban gyorsan és egyszerűen jóváhagyhatod a számlákat – minden releváns infó és művelet egy helyen.",
        "hrhover": "A myHR-ben kényelmesen eléred és kezeled a HR-rel kapcsolatos infóidat és feladataidat, egy helyen.",
        "concurhover": "A Concurban könnyen kezelheted és beadhatod az utazási és költségjelentéseidet – minden infó és művelet egy helyen.",
        "passwordhover": "Ezzel a csempével könnyen visszaállíthatod az SAP-rendszereid jelszavát.",
        "aribahover": "Az SAP Aribában könnyen kezelheted a beszerzési folyamataidat – minden fontos infó és eszköz egy helyen.",
        "itresourceshover": "IT erőforrások",
        "myassetshover": "Eszközeim",
        "orderhover": "Rendelés",
        "incidenthover": "Események",
        "beelinehover": "A Beeline-nal hatékonyan kezelheted a kontingens/külsős munkaerőt, és egyszerűsítheted a felvételi folyamatokat – minden szükséges eszköz és infó egy helyen.",
        "prismahover": "A PRISMA az Incidens- és Fenntarthatósági Menedzsment és Auditálás Jelentési Platformja. A platform támogatja az E.ON HSE csapatát abban, hogy az E.ON egészségtudatos, biztonságos és környezettudatos hely legyen. A PRISMA elérhető weben és appként is.",
        "gertrudhover": "Gertrud",
        "notificationhover": "Értesítési Portal",
        "zukohover": "Zuko",
        "eon_brandhover": "EON Márkaterület",
        "pkihover": "PKI Portal",
        "mailhover": "Mail DL",
        "journeyhover": "Utazások/Események",
        "mygeniushover": "MyGenius",
        "ideeonhover": "Az Idee.on egy platform, ahol a kollégák ötleteket és javaslatokat adhatnak be és értékelhetnek az ötletmenedzsmenthez. Célunk a folyamatos fejlesztés a vállalat minden területén.",
        "ideenethover": "Az IdeeNet egy igazi ötletmenedzsment szoftver. Széles körű ötletek, mint például &#10;&bull; Központosított BVW, decentralizált BVW és vegyes formák &#10;&bull; Minőségi körök és CIP &#10;&bull; Hibajelentések és panaszok &#10;&bull; Munkavállalói találmányok &#10;hatékonyan kezelhetők ezzel a szoftverrel egy egységes ötletadatbázisban, különféle stratégiákkal.",
        "dpfhover": "A személyi aktádban sokkal több dokumentum van, mint amit a MyHR-ben folyamatosan mutatunk! &#10;Adj be egy HR-kérést, és kérj hozzáférést a teljes személyi aktádhoz! Szakmai felülvizsgálat után közvetlen linken keresztül elérhetővé tesszük.",
        "corpsachover": "A SAC egy erős vizualizációs eszköz fejlett tervezési funkciókkal.",
        "corpportalhover": "A Vállalati Portal egy központi belső alkalmazásplatform szerepalapú integrációval és fejlesztéssel, amely SSO-hozzáférést ad az SAP háttérrendszerekhez.",
        "redwoodhover": "A Redwood FA-t a konszolidált pénzügyi kimutatások ütemezésére és az egyes tevékenységek automatizálására használjuk.",
        "eamsap200hover": "Vállalati eszközmenedzsment &#10;Önfejlesztési környezet az SAP üzleti technológiai platformján (BTP, korábban SAP Cloud Platform) – EAM fiók hálózati cockpitokhoz, a felhőpéldányokkal: termelés, QA, fejlesztés és staging.",
        "eamsap100hover": "Vállalati eszközmenedzsment &#10;Önfejlesztési környezet az SAP üzleti technológiai platformján (BTP, korábban SAP Cloud Platform) – EAM fiók hálózati cockpitokhoz, a felhőpéldányokkal: termelés, QA, fejlesztés és staging.",
        "sodsaphover": "Az SOD-Portal célja, hogy egyszerűbbé és digitálissá tegye a Feladatok Elkülönítésének (SoD) kezelését. Az SOD-konfliktusok azonosításának, követésének és megoldásának digitalizálásával segít betartani a szabályozásokat és növeli a szervezeti biztonságot. Nélkülözhetetlen eszköz az erős belső kontrollrendszerhez és az üzleti működés védelméhez.",
        "videonhover": "Alkalmazás szolgáltatások foglalására a Brüsseler Platz-i videó/TV stúdióból videó/TV-produkcióhoz vagy streaming eseményhez.",
        "alteryxhover": "Adat-analitikai platform analitikai appok és munkafolyamatok készítéséhez. Kezelheted és megoszthatod az analitikai appokat, futtathatod a munkafolyamatokat, és elérheted a kimeneteket és riportokat szerver környezetben.",
        "ebamhover": "Elektronikus bankszámlakezelés",
        "egshover": "Az E.ON SE kezességet és garanciát vállal a csoport üzleti egységei számára külső hitelezők felé.",
        "epsnexthover": "Központi elektronikus banki eszköz minden MU/BU számára.",
        "fisquantumhover": "A FIS Quantum Treasury Management megoldás célja, hogy hatékonyabbá és eredményesebbé tegye a kincstári folyamatokat. A felhőalapú platform valós idejű rálátást ad a készpénzre és likviditásra, így jobb döntéseket hozhatsz a tőke- és kockázatkezelésben. Fejlett funkcióival a kötelezettségek, befektetések és megfelelőség kezelésére egyszerűsíti a munkafolyamatokat és javítja a pénzügyi teljesítményt.",
        "rmshover": "E.ON csoportszintű kockázatkezelési rendszer (hitelkérelmek feldolgozása és hitelkockázat-kezelés).",
        "slidohover": "A Slido egy interaktív platform, amivel feldobhatod az élő vagy online eseményeket, meetingeket és prezentációkat. Csinálj élő szavazásokat, Q&A-t és kvízeket valós időben – a közönség imádni fogja a részvételt.",
        "insightslibraryhover": "Az Insights Könyvtár az E.ON központi tudásgyűjteménye az ügyfél- és piaci insightokhoz az ügyfélmegoldások üzletágban.",
        "getabstracthover": "A getAbstract az E.ON csoportszintű online könyvtára a getAbstracttól – könyvösszefoglalókkal, cikkekkel és további tanulási formátumokkal, amelyek lefedik az üzletileg releváns készségeket (soft és funkcionális skillek).",
        "mypotentialhover": "Rendszer az Egyesült Királyság dolgozóinak és vezetőinek a teljesítmény, célok és értékelések rögzítésére.",
        "dsesoftwarehover": "Képzések és értékelések az egészség és biztonság érdekében.",
        "whistleblowinghover": "A Whistleblowing eszköz bárkinek lehetővé teszi, hogy névtelenül bejelentést tegyen – webes űrlapon, e-mailben vagy telefonon. Telefonhívásnál a hangod torzítva lesz.",
        "maqsimahover": "Kockázatértékelések, üzemeltetési utasítások, veszélyes anyagok kezelése &#10;A Maqsima segít gyorsan és egyszerűen nyomon követni minden releváns kockázatértékelést és üzemeltetési utasítást, és okosan naprakészen tartani őket.",
        "digitalrulebookhover": "A Paula Policy az E.ON vállalati irányelvek mesterségesintelligencia-alapú asszisztense. Gyors, egyszerű hozzáférést ad a People Guidelines, a Function Policies és a Code of Conduct dokumentumokhoz – következetes, megbízható válaszokkal, érthetővé téve a komplex szabályokat.",
        "oneERPhover": "Az one.ERP Portal egy központi platform a Westenergie csoportban, ami összefogja az ERP-hez kapcsolódó funkciókat és infókat. Infó- és irányítási központ az ERP-felhasználóknak és IT-vezetőknek, a csoport digitális stratégiájának részeként.",
        "Perseushover": "A Biztonsági Portal a központi belépési pont a biztonsági incidensek bejelentésére a Westenergie és Westnetz szervezetekben. Gyakran együtt használják a belső Perseus jelentési rendszerrel (pl. eszközvesztés, lopás, adatvédelmi incidensek).",
        "cateringportalhover": "Az eon.cateringportal.io az E.ON Kantin App digitális platformja. Étlapokat, helyszíni infókat és egyéb catering szolgáltatásokat találsz itt E.ON dolgozóként.",
        "westnetzregelwerkehover": "Központi portál a villamos- és gázhálózatok üzemeltetéséhez kapcsolódó műszaki szabályzatokhoz és dokumentációkhoz. Minden fontos irányelv, szabvány és műszaki specifikáció elérhető a biztonságos, hatékony hálózati működéshez.",
        "werbemittelhover": "A Westenergie Reklámanyagok Boltja egy online platform, ahol a Westenergie csoport dolgozói és meghatalmazott partnerei reklám- és kommunikációs anyagokat rendelhetnek.",
        "westenergie_brandhover": "A Westenergie képadatbázis, valamint a Westenergie csoport márkaelemei és dizájnirányelvei. Hozzáférés a márkánk minden összetevőjéhez, hogy igazi Westenergie-pillanatokat teremtsünk – a márkamenedzsment rendszertől (logók, szimbólumok, chat doboz használata stb.) a médiakönyvtárig, rengeteg képpel minden dizájnváltozathoz.",
        "compasshover": "A Compass az E.ON csoportszintű belső kommunikációs platformja hírekhez, tartalmakhoz, hálózatépítéshez és kollégák közti cseréhez.",
        "gradarhover": "Eszköz a vezetői munkakörök besorolási folyamatának elindításához.",
        "beqomhover": "A beqomot csoportszinten használjuk az E.ON hosszú távú ösztönzőinek adminisztrációjára és kommunikációjára (HR, könyvelés, adó, vezetők). Emellett fizetési és bónuszlevelek, illetve teljes javadalmazási kimutatások is készíthetők benne.",
        "kychover": "A Know-Your-Counterpart (KYC) eszközzel a partnereket szabványos irányelvek szerint (pl. PG-03) szűrheted.",
        "talentryhover": "Használd ki ezt a lehetőséget: oszd meg aktuális állásainkat tehetséges ismerőseiddel – azokkal, akik energiájukkal alakítanák a jövőt.",
        "samhover": "Ezzel az eszközzel elvégezheted a kötelező biztonsági képzéseket.",
        "enormhover": "Az e-NORM egy erős szoftver a minőségbiztosításhoz és szabványdokumentumokhoz kapcsolódó adatok kezelésére, frissítésére, valamint a kapcsolódó fájlok összekapcsolására.",
        "redonlinehover": "A Red-on-line (ROL) Compliance Monitor leegyszerűsíti a megfelelőség kezelését, valós idejű frissítéseket ad az EHS-szabályozásokról, monitorozással és dashboardokkal. Segít proaktívan kezelni a kockázatokat és javítani a működési hatékonyságot.",
        "tagetikcpmhover": "Tagetik Vállalati Teljesítménymenedzsment (CPM) alkalmazás költségvetés-tervezéshez, konszolidációhoz, kockázati és vezetői riportokhoz (Pénzügyi Kiválóság) az E.ON SE-nek (Csoportjelentés). Fő folyamatok: negyedéves zárások – nagy külső hatással a tőkepiaci kommunikáció határidői miatt.",
        "tagetikcpmermhover": "Tagetik CPM és ERM alkalmazás költségvetés-tervezéshez, konszolidációhoz, kockázati és vezetői riportokhoz (Pénzügyi Kiválóság) az E.ON SE-nek (Csoportjelentés). Fő folyamatok: negyedéves zárások – nagy külső hatással a tőkepiaci kommunikáció határidői miatt.",
        "smartguidehover": "A Smart Guide Hub egy wiki, amit pár kolléga szerkesztőként tart karban, és kb. 4000 felhasználónak ad iránymutatást IFRS, Controlling, HGB és ESG témákban.",
        "tagetiksachover": "Tagetik Dashboard. A Tagetik egy alkalmazás költségvetés-tervezéshez, konszolidációhoz, kockázati és vezetői riportokhoz (Pénzügyi Kiválóság) az E.ON SE-nek (Csoportjelentés). Fő folyamatok: negyedéves zárások – nagy külső hatással a tőkepiaci kommunikáció határidői miatt.",
        "myithover": "A te go-to forrásod minden IT-ügyhöz: támogatási lehetőségek, hasznos linkek, közösségek és a legfrissebb hírek, amikről jó, ha tudsz.",
        "servicehub": "Szolgáltatási Központ",
        "servicehubhover": "Az EON Szolgáltatási Központban könnyen kérhetsz új szoftvert és hardvert (laptop, monitor stb.), és IT-támogatást is kaphatsz: bejelenthetsz hibát, vagy csetelhetsz a Globális Szolgáltatási Asztallal – mindezt egy helyen.",
        "SailPoint": "Identitáskezelés áttekintése",
        "P29": "SAP EIC",
        "P83": "SAP EIC",
        "BIC": "BIC Cloud / BIC folyamat-tervezés",
        "Celonis": "Celonis Folyamatbányászat",
        "Carsync": "Carsync Flottakezelés",
        "ISUSpace": "ISU/Space",
        "GNIS": "GNIS (EDI)",
        "ecount_EDI": "ecount EDI",
        "SAP_Datasphere_EDI": "SAP Datasphere EDI",
        "SailPointhover": "A SailPointtal központilag kezelheted a hozzáférési jogokat és azonosításokat.",
        "P29hover": "Az SAP EIC-ben a jegyeket és ügyfélkéréseket hatékonyan feldolgozhatod és dokumentálhatod. Támogatja az ECG-integrációt és központi felületet ad a jegykezeléshez.",
        "P83hover": "Az SAP EIC-ben a jegyeket és ügyfélkéréseket hatékonyan feldolgozhatod és dokumentálhatod. Támogatja az ECG-integrációt és központi felületet ad a jegykezeléshez.",
        "BIChover": "A BIC Cloudban modellezheted, elemezheted és optimalizálhatod az üzleti folyamataidat.",
        "Celonishover": "Folyamatbányászat: Valós folyamatok elemzése eseménynaplók alapján ERP, CRM és más rendszerekből. Végrehajtáskezelés: Munkafolyamatok automatizálása és cselekvési ajánlások. Folyamatoptimalizálás: Hatékonysági problémák azonosítása, pl. a Beszerzés–Fizetés vagy Rendelés–Készpénz folyamatokban. Integráció: Kapcsolódás rendszerekhez, mint SAP, Salesforce, Oracle stb.",
        "Carsynchover": "A Carsync-cel hatékonyan kezelheted a céges autókat és a flottát, dokumentálhatod az utakat, és optimalizálhatod a költségeket.",
        "ISUSpacehover": "Az ISU/Space-ben könnyen foglalhatsz és kezelhetsz munkahelyeket és tárgyalókat.",
        "GNIShover": "A GNIS-szel a piaci kommunikációhoz (EDI) szükséges törzs- és hálózati adatokat hatékonyan kezelheted és cserélheted.",
        "ecount_EDIhover": "Az eccountban az EDI-releváns törzs- és hálózati adatokat kezelheted, cserélheted és elemezheted.",
        "SAP_Datasphere_EDIhover": "Az SAP Datasphere-rel különböző források adatait integrálhatod, modellezheted és elérhetővé teheted elemzéshez és döntéshozatalhoz. Támogatja az önkiszolgálást, az adatkezelést és a valós idejű hozzáférést.",
        "CFLP": "CFLP",
        "corporateWorkspace": "Corporate Workspace",
        "SAPWebLaunchpad": "SAP Web Launchpad",
        "CFLPhover": "Központi belépési pont az SAP rendszerekhez és felhőszolgáltatásokhoz.",
        "corporateWorkspacehover": "Az SAP Build Work Zone, Advanced Editionnel digitális munkaterületeket hozhatsz létre, hogy nőjön a felhasználói produktivitás és elköteleződés. Egyesíti az üzleti appokhoz, folyamatokhoz, infókhoz és kommunikációhoz való hozzáférést egy egységes belépési ponton – bármilyen eszközről.",
        "SAPWebLaunchpadhover": "Az SAP Web Launchpad a weben keresztül ad hozzáférést SAP rendszerekhez Fiori és WebGUI használatával. A testreszabható kezdőoldal (kedvencekkel) gyors elérést ad az SAP rendszerekhez és kliensekhez.",
        "PKI_Semnatura_Digitala_6781": "PKI - Digitális aláírás",
        "Users_Access_EER_9163": "RAPPS EER",
        "Evaluare_Personal_EER_2935": "Munkavállalói értékelés EER",
        "Sesizari_Administrare_Cladiri_EER_8543": "Épületüzemeltetési bejelentések EER",
        "MRBS_EER_8445": "MRBS EER",
        "Delegatii_EER_1137": "Kiküldetések EER",
        "Users_Access_EER_5369": "Felhasználói hozzáférés EER",
        "Planificare_Concedii_EER_8588": "Szabadságtervezés EER",
        "Pontaje_si_Telemunca_EER_7087": "Jelenléti ív és távmunka EER",
        "BOT_6231": "BOT",
        "Bonusare_personal_6879": "Dolgozói bónusz",
        "GRC_Request_5510": "GRC kérelem",
        "iPEN_Portal_3047": "iPEN portál",
        "YourVoiceEON_0693": "YourVoice@E.ON",
        "ITPortal_5530": "IT-portál (Süwag)",
        "Transf4m_Ticket_Tool_6635": "Transf4m Ticket Tool (Süwag)",
        "Speedikon_C_1281": "Speedikon C (Süwag)",
        "Speiseplan_8904": "Speiseplan (Süwag)",
        "Ariba_8690": "Ariba",
        "DiSch_20_0545": "DiSch 2.0",
        "ISMSMeldezentrale_9318": "ISMS-Meldezentrale (Süwag)",
        "SAP_Launchpad_8736": "SAP Launchpad (Süwag)",
        "HR_Portal_3311": "HR Portal (Süwag)",
        "Confluence_9100": "Confluence (Süwag)",
        "my_IT_order_6623": "my IT order",
        "BAT_Business_Activity_Tracker_7022": "BAT PL",
        "CTP_2407": "CTP PL",
        "BPM_OSD_PL_5209": "BPM OSD PL",
        "jflow_PL_6875": "jflow PL",
        "Qmatic_PL_CS_3195": "Qmatic PL CS",
        "Qmatic_PL_EN_3118": "Qmatic PL EN",
        "CCM_Inspire_7264": "CCM Inspire",
        "Atoss_artelisGruppe_und_VSEAgentur_3137": "Atoss artelis-Gruppe und VSE-Agentur",
        "Atoss_VSEGruppe_4374": "Atoss VSE-Gruppe",
        "AWS_Access_Portal_1318": "AWS Access Portal",
        "eDIVA_5372": "eDIVA",
        "G2G_VSEGruppe_6518": "G2G VSE-Gruppe",
        "AWS_Access_Portal_6740": "AWS Access Portal",
        "Qualys_Security_4331": "Qualys Security",
        "ODIN_FinOps_6411": "ODIN FinOps",
        "Cloudflare_4507": "Cloudflare",
        "ADP_TRAVEL_REISEMANAGEMENT_3368": "ADP TRAVEL REISEMANAGEMENT",
        "ITSicherheitsvorfall_melden_VSEGruppe_9292": "IT-Sicherheitsvorfall melden VSE-Gruppe",
        "HSE_Sicherheitsvorfall_melden_VSEGruppe_9987": "HSE Sicherheitsvorfall melden VSE-Gruppe",
        "Speiseplan_VSEGruppe_3571": "Speiseplan VSE-Gruppe",
        "ITMeldebogen_VSEGruppe_1367": "IT-Meldebogen VSE-Gruppe",
        "LeanIX_5372": "LeanIX",
        "VSE_Wiki_CONFLUENCE_1902": "VSE Wiki CONFLUENCE",
        "Young_Talents_AzubiPortal_3338": "Young Talents Azubi-Portal",
        "Workday_Peakon_eNPS_1749": "Workday Peakon eNPS",
        "Umantis_0386": "Umantis",
        "Adeverinte_alte_aplicatii_HR_RO_CS_2447": "Igazolások és egyéb HR-alkalmazások (RO CS)",
        "Deconturi_card_companie_RO_CS_5333": "Elszámolás vállalati bankkártyával (RO CS)",
        "Documente_delegatii_RO_CS_5332": "Kiküldetési dokumentumok (RO CS)",
        "SAP_ISU_CS_RO_8555": "SAP IS-U CS RO",
        "PKI_Semnatura_Digitala_6781hover": "Token visszaállítása",
        "Users_Access_EER_9163hover": "RAPPS EER",
        "Evaluare_Personal_EER_2935hover": "Munkavállalói értékelési portál EER",
        "Sesizari_Administrare_Cladiri_EER_8543hover": "Épületüzemeltetési bejelentési portál EER",
        "MRBS_EER_8445hover": "Tárgyalóterem-foglalás EER",
        "Delegatii_EER_1137hover": "Kiküldetési portál EER",
        "Users_Access_EER_5369hover": "Felhasználói hozzáférési űrlap EER",
        "Planificare_Concedii_EER_8588hover": "Szabadságtervezés EER",
        "Pontaje_si_Telemunca_EER_7087hover": "Jelenléti ív és távmunka EER",
        "BOT_6231hover": "Üdülési és gyógykezelési jegyek térítésének igénylése",
        "Bonusare_personal_6879hover": "Dolgozói bónusz",
        "GRC_Request_5510hover": "A GRC (Governance & Risk Compliance Access Control) egy SAP workflow-eszköz, amivel automatizáltan igényelheted, jóváhagyhatod és hozzárendelheted a felhasználói jogosultságokat az SAP-rendszerekben.",
        "iPEN_Portal_3047hover": "Az Information Platform of Energy Networks (iPEN) biztosítja, hogy a regionális egységek adatai központilag összegyűjthetők és elérhetők legyenek. A meglévő és újonnan fejlesztett intelligens megoldások csatlakoznak a platformhoz, így költséghatékonyan, gyorsan és rugalmasan vezethetők be a teljes hálózati közösségben. Az iPEN a smart megoldások skálázásának kulcsa.",
        "YourVoiceEON_0693hover": "A PEAKON platform hetente kb. 4–5 kérdést küld a jólléteddel és aktuális munkakörülményeiddel kapcsolatban. A kérdéseket értékelheted (0–10), írhatsz megjegyzést, vagy átugorhatod őket. Válaszolni tényleg csak 1–2 perc.",
        "ITPortal_5530hover": "A Süwag IT-szolgáltatási portálja",
        "Transf4m_Ticket_Tool_6635hover": "Transf4m Ticket Tool",
        "Speedikon_C_1281hover": "Speedikon C",
        "Speiseplan_8904hover": "Étlap",
        "Ariba_8690hover": "Beszerzési portál",
        "DiSch_20_0545hover": "Ez a te digitális munkahelyed",
        "ISMSMeldezentrale_9318hover": "ISMS-Meldezentrale",
        "SAP_Launchpad_8736hover": "SAP Launchpad",
        "HR_Portal_3311hover": "HR Portal",
        "Confluence_9100hover": "A Süwag Confluence-je",
        "my_IT_order_6623hover": "my IT order",
        "BAT_Business_Activity_Tracker_7022hover": "Időjelentés",
        "CTP_2407hover": "CTP (Az idő pénz)",
        "BPM_OSD_PL_5209hover": "BPM PP + CRM DSO",
        "jflow_PL_6875hover": "Üzleti folyamatok kezelése Jira-val",
        "Qmatic_PL_CS_3195hover": "Alkalmazás az ügyfélforgalom (sorok) kezelésére a POS-ban",
        "Qmatic_PL_EN_3118hover": "Alkalmazás az ügyfélforgalom (sorok) kezelésére a POS-ban",
        "CCM_Inspire_7264hover": "Az E.ON központosított ügyfélkommunikáció-kezelési (CCM) platformja, a Quadient Inspire technológiával az ügyfélkommunikáció létrehozásához és kézbesítéséhez.",
        "Atoss_artelisGruppe_und_VSEAgentur_3137hover": "Ez a mi időkövetési rendszerünk",
        "Atoss_VSEGruppe_4374hover": "Ez a mi időkövetési rendszerünk",
        "AWS_Access_Portal_1318hover": "Hozzáférés az AWS-fiókokhoz",
        "eDIVA_5372hover": "ANF felhasználókezelés",
        "G2G_VSEGruppe_6518hover": "A VSE-Gruppe GIS rendszere",
        "AWS_Access_Portal_6740hover": "Hozzáférés a VSE-Gruppe AWS Cloud rendszeréhez",
        "Qualys_Security_4331hover": "Vállalati kockázatfigyelés",
        "ODIN_FinOps_6411hover": "ODIN FinOps VSE-Gruppe",
        "Cloudflare_4507hover": "Cloudflare VSE-Gruppe",
        "ADP_TRAVEL_REISEMANAGEMENT_3368hover": "ADP TRAVEL REISEMANAGEMENT  VSE-Gruppe",
        "ITSicherheitsvorfall_melden_VSEGruppe_9292hover": "IT-biztonsági incidens bejelentése VSE-Gruppe",
        "HSE_Sicherheitsvorfall_melden_VSEGruppe_9987hover": "HSE-incidens bejelentése VSE-Gruppe",
        "Speiseplan_VSEGruppe_3571hover": "Étlap VSE-Gruppe",
        "ITMeldebogen_VSEGruppe_1367hover": "IT bejelentőlap VSE-Gruppe",
        "LeanIX_5372hover": "LeanIX",
        "VSE_Wiki_CONFLUENCE_1902hover": "Útmutatók",
        "Young_Talents_AzubiPortal_3338hover": "Young Talents Azubi-Portal VSE-Gruppe",
        "Workday_Peakon_eNPS_1749hover": "Workday Peakon eNPS",
        "Umantis_0386hover": "Umantis VSE-Gruppe",
        "Adeverinte_alte_aplicatii_HR_RO_CS_2447hover": "Az alkalmazás célja, hogy minden felhasználó legfeljebb három kattintással tölthessen le különféle igazolásokat. A HR-adminisztrátorok és csapatkoordinátorok a hozzájuk tartozó kollégák igazolásait is letölthetik. Emellett a munkavállalók kiszámíthatják szolgálati idejüket és nyugdíjazási támogatásukat, valamint további dokumentumokat kérhetnek a HR-osztálytól.",
        "Deconturi_card_companie_RO_CS_5333hover": "A vállalati bankkártyák birtokosai egyszerűen nyújthatják be költségelszámolásaikat anélkül, hogy a bizonylatokat e-mailben vagy postán kellene elküldeniük, illetve e-mailben kellene jóváhagyást kérniük. A teljes folyamat ezen a platformon zajlik.",
        "Documente_delegatii_RO_CS_5332hover": "A kiküldetések kezelésére szolgáló alkalmazásban a felhasználók dokumentumokat adhatnak hozzá saját és beosztottjaik kiküldetéseihez. A HR-adminisztrátorok tömegesen tekinthetik meg, szűrhetik és zárhatják le a dokumentumokat, valamint automatikusan küldött e-mailekben további dokumentumokat kérhetnek.",
        "SAP_ISU_CS_RO_8555hover": "A szolgáltatás az E.ON RO CS által használt SAP IS-U x7G rendszerekkel kapcsolatos tevékenységeket fedi le.",
        "subTitle": {
            "PKI_Semnatura_Digitala_6781SubTitle": "Token megújítása / visszaállítása",
            "Users_Access_EER_9163subTitle": "RAPPS EER",
            "Evaluare_Personal_EER_2935subTitle": "Munkavállalói értékelési portál EER",
            "Sesizari_Administrare_Cladiri_EER_8543subTitle": "Épületüzemeltetési bejelentési portál EER",
            "MRBS_EER_8445subTitle": "Tárgyalóterem-foglalás EER",
            "Delegatii_EER_1137subTitle": "Kiküldetési portál EER",
            "Users_Access_EER_5369subTitle": "Felhasználói hozzáférési űrlap EER",
            "Planificare_Concedii_EER_8588subTitle": "Szabadságtervezés EER",
            "Pontaje_si_Telemunca_EER_7087subTitle": "Jelenléti ív és távmunka EER",
            "BOT_6231subTitle": "Üdülési és gyógykezelési jegyek térítésének igénylése",
            "Bonusare_personal_6879subTitle": "Dolgozói bónusz",
            "GRC_Request_5510SubTitle": "GRC kérelem",
            "iPEN_Portal_3047SubTitle": "Energiahálózatok információs platformja",
            "YourVoiceEON_0693SubTitle": "YourVoice@E.ON",
            "ITPortal_5530SubTitle": "Süwag",
            "Transf4m_Ticket_Tool_6635SubTitle": "JIRA",
            "Speedikon_C_1281SubTitle": "Munkahelyfoglalás",
            "Speiseplan_8904SubTitle": "Höchst",
            "Ariba_8690SubTitle": "Beszerzési portál",
            "DiSch_20_0545SubTitle": "Digitális munkahely",
            "ISMSMeldezentrale_9318SubTitle": "Süwag",
            "SAP_Launchpad_8736SubTitle": "WEB",
            "HR_Portal_3311SubTitle": "Selfservices",
            "Confluence_9100SubTitle": "Süwag",
            "my_IT_order_6623SubTitle": "E.ON",
            "BAT_Business_Activity_Tracker_7022SubTitle": "Üzleti tevékenység nyomon követése",
            "CTP_2407SubTitle": "Czas to pieniądz",
            "BPM_OSD_PL_5209SubTitle": "BPM PP + CRM DSO",
            "jflow_PL_6875SubTitle": "Üzleti folyamatok kezelése",
            "Qmatic_PL_CS_3195SubTitle": "Qmatic E.ON Polska",
            "Qmatic_PL_EN_3118SubTitle": "Qmatic Stoen Operator",
            "CCM_Inspire_7264SubTitle": "CCM - Platform",
            "Atoss_artelisGruppe_und_VSEAgentur_3137SubTitle": "artelis-Gruppe und VSE-Agentur",
            "Atoss_VSEGruppe_4374SubTitle": "Atoss VSE-Gruppe",
            "AWS_Access_Portal_1318SubTitle": "IT - CloudCore",
            "eDIVA_5372SubTitle": "eDIVA ANF felhasználókezelés -> eDIVA",
            "G2G_VSEGruppe_6518SubTitle": "G2G VSE-Gruppe",
            "AWS_Access_Portal_6740SubTitle": "AWS Access Portal VSE-Gruppe",
            "Qualys_Security_4331SubTitle": "Qualys Security VSE-Gruppe",
            "ODIN_FinOps_6411SubTitle": "ODIN FinOps VSE-Gruppe",
            "Cloudflare_4507SubTitle": "Cloudflare VSE-Gruppe",
            "ADP_TRAVEL_REISEMANAGEMENT_3368SubTitle": "ADP TRAVEL REISEMANAGEMENT  VSE-Gruppe",
            "ITSicherheitsvorfall_melden_VSEGruppe_9292SubTitle": "IT-biztonsági incidens bejelentése VSE-Gruppe",
            "HSE_Sicherheitsvorfall_melden_VSEGruppe_9987SubTitle": "HSE-incidens bejelentése VSE-Gruppe",
            "Speiseplan_VSEGruppe_3571SubTitle": "Étlap VSE-Gruppe",
            "ITMeldebogen_VSEGruppe_1367SubTitle": "IT bejelentőlap VSE-Gruppe",
            "LeanIX_5372SubTitle": "LeanIX",
            "VSE_Wiki_CONFLUENCE_1902SubTitle": "VSE Wiki CONFLUENCE",
            "Young_Talents_AzubiPortal_3338SubTitle": "Young Talents Azubi-Portal VSE-Gruppe",
            "Workday_Peakon_eNPS_1749SubTitle": "Workday Peakon eNPS",
            "Umantis_0386SubTitle": "Umantis VSE-Gruppe",
            "Adeverinte_alte_aplicatii_HR_RO_CS_2447SubTitle": "Igazolások és egyéb HR-alkalmazások (RO CS)",
            "Deconturi_card_companie_RO_CS_5333SubTitle": "Elszámolás vállalati bankkártyával (RO CS)",
            "Documente_delegatii_RO_CS_5332SubTitle": "Kiküldetési dokumentumok (RO CS)",
            "SAP_ISU_CS_RO_8555SubTitle": "SAP IS-U CS RO",
            "CFLPSubTitle": "Központi Fiori Launchpad",
            "corporateWorkspaceSubTitle": "SAP Build Work Zone, Advanced Edition",
            "SAPWebLaunchpadSubTitle": "Hivatkozások SAP rendszerekhez",
            "timeSubTitle": "CATS",
            "meetingSubTitle": "GINGCO",
            "approvalSubTitle": "SNOW/SAP",
            "prSubTitle": "BANF",
            "praSubTitle": "BANF",
            "processingSubTitle": "SAP",
            "hrSubTitle": "MyHR",
            "concurSubTitle": "SAP Concur",
            "passwordSubTitle": "SAP rendszerek",
            "aribaSubTitle": "PO Áttekintés",
            "itresourcesSubTitle": "SNOW",
            "incidentSubTitle": "SNOW",
            "orderSubTitle": "IT szolgáltatások rendelése",
            "myassetsSubTitle": "SNOW",
            "beelineSubTitle": "Külső felvétel",
            "prismaSubTitle": "HSE",
            "gertrudSubTitle": "Igazgatósági ülések előkészítése",
            "notificationSubTitle": "Létesítmény szolgáltatások",
            "zukoSubTitle": "Irodaköltözés szervezése",
            "eon_brandSubTitle": "miénk",
            "pkiSubTitle": "Tanúsítványok kezelése",
            "mailSubTitle": "Karbantartás",
            "journeySubTitle": "FuV §37b EstG",
            "mygeniusSubTitle": "Digitális Tanulási Platform",
            "ideeonSubTitle": "Ötletmenedzsment",
            "ideenetSubTitle": "Ötletmenedzsment",
            "dpfSubTitle": "Digitális Személyi Akta",
            "corpsacSubTitle": "SAC",
            "corpportalSubTitle": "Vállalati Portal",
            "redwoodSubTitle": "Redwood FA",
            "eamsap200SubTitle": "SAP Cloud Cockpits (200)",
            "eamsap100SubTitle": "SAP Cloud Cockpits (100)",
            "sodsapSubTitle": "SoD-Portal",
            "videonSubTitle": "VidEON",
            "alteryxSubTitle": "Alteryx",
            "ebamSubTitle": "EBAM",
            "egsSubTitle": "EGS",
            "epsnextSubTitle": "EPSnext",
            "fisquantumSubTitle": "FIS Quantum",
            "rmsSubTitle": "RMS",
            "slidoSubTitle": "Slido",
            "insightslibrarySubTitle": "Tudásgyűjtemény",
            "getabstractSubTitle": "Online Könyvtár",
            "mypotentialSubTitle": "AMP",
            "dsesoftwareSubTitle": "DSE",
            "whistleblowingSubTitle": "E.ON Whistleblowing Megoldás",
            "maqsimaSubTitle": "Kockázatértékelések kezelése",
            "digitalrulebookSubTitle": "Csoport Irányelvek",
            "oneERPSubTitle": "EAM/ESM",
            "PerseusSubTitle": "Perseus",
            "cateringportalSubTitle": "Cateringportal",
            "westnetzregelwerkeSubTitle": "nScale",
            "werbemittelSubTitle": "Reklámanyagbolt",
            "westenergie_brandSubTitle": "Westenergie Frontify",
            "compassSubTitle": "Csoportszintű Belső Kommunikációs Platform",
            "gradarSubTitle": "Munkakör értékelés és kompenzáció",
            "beqomSubTitle": "beqom",
            "kycSubTitle": "Megfelelőségi Partnerellenőrzés",
            "talentrySubTitle": "Állásajánlási program",
            "samSubTitle": "Biztonsági Képzés @E.On",
            "enormSubTitle": "Megfelelőségi Monitor",
            "redonlineSubTitle": "red-on-line",
            "tagetikcpmSubTitle": "CPM",
            "tagetikcpmermSubTitle": "CPM és ERM",
            "smartguideSubTitle": "Smart Guide Hub (Számviteli Wiki)",
            "tagetiksacSubTitle": "Tagetik SAP Analytics Cloud",
            "servicehubSubTitle": "Szolgáltatási Központ",
            "myitSubTitle": "IT Támogatás és Hírek",
            "SailPointSubTitle": "Identitás- és hozzáféréskezelés áttekintése",
            "P29SubTitle": "SAP EIC",
            "P83SubTitle": "SAP P83",
            "BICSubTitle": "BIC Cloud",
            "CelonisSubTitle": "Folyamatbányászat",
            "CarsyncSubTitle": "Flottakezelés",
            "ISUSpaceSubTitle": "Munkahely és Tárgyalóterem Kezelés",
            "GNISSubTitle": "EDI Törzsadatkezelés",
            "ecount_EDISubTitle": "EDI Adatkezelés",
            "SAP_Datasphere_EDISubTitle": "Adatintegráció és Üzleti Adat Fabric",
            "ukhrSubTitle": "UK HR App"
        },
        "ukhr": "UK HR App",
        "ukhrhover": "Az egyablakos megoldásod minden UK HR-dologhoz. A fizetési jegyzéktől a szabadságfoglalásig – és minden, ami közte van. Kezdd az alkalmazotti és vezetői útmutatóinkkal, vagy keress az alábbi HR-ben."
    },
    "searchPage": {
        "searchPlaceholder": "Keress...",
        "searchApps": "Keress itt...",
        "relatedApps": "Appok",
        "viewMoreApps": "Még több",
        "removeAppTooltip": "Vedd le a Dashboardról",
        "addAppTooltip": "Tedd a Dashboardra",
        "addedAppTooltip": "Hozzáadva a Dashboardra"
    },
    "pwaText": {
        "header": "Telepítsd ezt az appot a kezdőképernyődre!",
        "button": "Telepítsd az appot",
        "iphoneHeader": "Tedd fel az appot iPhone-ra",
        "inst1": "Koppints a <b>Megosztás</b> gombra a Safariban.",
        "inst2": "Görgess le, és válaszd a <b>„Hozzáadás a kezdőképernyőhöz”</b> opciót.",
        "inst3": "Koppints a <b>Hozzáadás</b> gombra a jobb felső sarokban."
    },
    "filterPage": {
        "filterMenu": {
            "backBtn": "Vissza az előző oldalra",
            "disclaimer": "Lehet, hogy néhány találat nem teljesen releváns. Kérlek, nézd át alaposan.",
            "loading": "Betöltés...",
            "app": "Appok",
            "gitlab": "Gitlab",
            "apps": "Appok",
            "all": "Összes",
            "m365": "Fájljaim",
            "jql": "jql",
            "people": "Emberek",
            "emails": "E-mailjeim",
            "teams": "Csapatok",
            "community": "Közösség",
            "pages": "Oldalak",
            "users": "Felhasználók",
            "noData": "Nincs találat",
            "noMoreData": "Nincs több találat a lekérdezésedre!",
            "filterHeading": "Szűrők",
            "reset": "Szűrők visszaállítása",
            "refineResults": "Finomítsd az eredményeket",
            "card_languages": "Nyelvek",
            "ecl_source_name": "Forrás",
            "standard_card_type": "Típus",
            "mimeType": "Típus",
            "datasources": "Adatforrások",
            "lookingFor": "Ezt keresem",
            "timeRange": "Időintervallum",
            "department": "Osztály",
            "mygenius": "My Genius",
            "jira": "Jira",
            "confluence": "Confluence",
            "orderit": "My IT order",
            "aiAssistant": "Segítő",
            "space": "Tér",
            "time": "Idő",
            "priority": "Prioritás",
            "status": "Állapot",
            "compass": "Iránytű",
            "contentType": "Kategória",
            "kb_articles": "IT támogatás",
            "officeBuddy": "E.ON tudásbázis",
            "key": "Projekt",
            "enterSearchTerm": "Írd be a keresőkifejezésed, és finomítsd az eredményeket.",
            "categoryTags": "Kategória",
            "companyTags": "Üzleti terület",
            "searchIn": "Itt keress"
        },
        "searchResult": {
            "source": "Forrás",
            "business": "Üzletág",
            "mobile": "Mobil",
            "type": "Típus",
            "duration": "Időtartam",
            "category": "Kategória",
            "deliveryTime": "Szállítási idő",
            "availableLanguages": "Elérhető nyelvek",
            "status": "Állapot",
            "lastUpdate": "Utolsó frissítés",
            "lastUpdated": "Legutóbb frissítve",
            "createdOn": "Létrehozva",
            "createdBy": "Készítette",
            "company": "Cég",
            "department": "Osztály",
            "job_title": "Munkakör",
            "office_location": "Iroda helye",
            "email": "E-mail",
            "preview": "Előnézet",
            "viewEmail": "E-mail megtekintése"
        },
        "timeRangeOptions": {
            "All": "Összes",
            "yesterday": "Tegnap",
            "lastWeek": "Elmúlt 7 nap",
            "lastMonth": "Elmúlt 1 hónap",
            "6 Months": "Elmúlt 6 hónap",
            "lastYear": "Elmúlt 1 év"
        },
        "dataSources": {
            "Confluence": "Confluence",
            "Gitlab": "Gitlab",
            "JIRA": "Jira",
            "MyGenius": "MyGenius",
            "ItOrder": "my IT order",
            "Sharepoint": "SharePoint",
            "Knowledge Base": "Tudásbázis",
            "powerpoint": "PowerPoint",
            "word": "Word",
            "excel": "Excel",
            "pdf": "PDF",
            "loop": "Loop",
            "other": "Egyéb"
        },
        "searchOptions": {
            "local": "<BU>",
            "compassWide": "Összes üzleti terület"
        },
        "searchOptionsHover": "Megmutatja a saját üzleti területed, az E.ON-csoport vagy más üzleti területek tartalmait."
    },
    "chatBot": {
        "dislikeDialog": {
            "title": "Visszajelzés megosztása",
            "irrelevant": "A válasz nem volt releváns",
            "incorrect": "Az információ helytelen volt",
            "detail": "A válasz nem volt elég részletes",
            "other": "Egyéb",
            "comments": "További megjegyzések",
            "placeholder": "Mondjon többet a visszajelzéséről (opcionális)",
            "later": "Talán később",
            "submit": "Visszajelzés küldése",
            "error": "A visszajelzést nem sikerült elküldeni. Próbálja újra."
        },
        "chatIcon": "ChatBot",
        "sourceName": "Forrás",
        "searchBack": "Vissza az előző oldalra",
        "welcomeMessage": "Üdv a chatben!",
        "chatbotPlaceholder": "Írj ide...",
        "sendbtn": "Küldés",
        "cancelBtn": "Mégse",
        "showMore": "Mutass többet",
        "showMoreTooltip": "Mutasd a teljes választ",
        "showLess": "Mutass kevesebbet",
        "showLessTooltip": "A teljes válasz összecsukása",
        "continueAssistance": "Folytatás a Segítséggel",
        "continueAssistanceTooltip": "Folytasd a Segítséggel, és tegyél fel még kérdéseket",
        "feedbackTitle": "Hasznos volt?",
        "feedbackThumbsUpLabel": "Igen, segített",
        "feedbackThumbsDownLabel": "Nem, még mindig segítség kell",
        "feedbackPrompt": "Itt írd meg a véleményed",
        "askMe": "Tedd fel a kérdésed",
        "imageUpload": "Kép feltöltése",
        "uploadImageTooltip": "Tölts fel egy képet, és tegyél fel egy kérdést.",
        "uploadImageFormat": "Támogatott formátum: JPG/PNG",
        "uploadImageProcessing": "A kép feldolgozása...",
        "uploadImageQuestions": "Javasolt kérdések:",
        "card": {
            "selfService": "Önkiszolgálás",
            "efficiency": "Hatékonyság",
            "ngService": "Következő generációs szolgáltatás"
        },
        "disclaimerText": "Felhívjuk a figyelmedet, hogy minden választ mesterséges intelligencia generál, és azok hibákat tartalmazhatnak.",
        "selfServiceTitle": "IT Támogatás",
        "selfServiceContent": "AI-alapú önkiszolgáló támogatás, hogy gyorsan megoldjuk a szolgáltatási incidenseket",
        "knowledgeBaseTitle": "Tudásbázis",
        "knowledgeBaseContent": "Jobb munkahelyi élmény hasznos infókkal",
        "internetSearchTitle": "Általános kérdések",
        "wentWell": "Mi ment jól? (nem kötelező)",
        "wentWrong": "Mi nem ment jól?",
        "privacyMsg": "Tiszteletben tartjuk a magánéleted, és bizalmasan kezeljük a visszajelzésed.",
        "appreciateService": "Köszi, hogy segítesz jobbá tenni a szolgáltatásainkat.",
        "feedbackMessage": "Köszi a visszajelzésed!",
        "relevantSearches": "Legrelevánsabb keresések",
        "aiAssitanceSuggestion": "Az alábbi mezőben kérdéseket tehetsz fel az AI Segítségnek",
        "aiActionMsg": "Úgy tűnik, megtelt a belső tárhelyed. Segíthetek a telepítési gondot megoldani: automatikusan törlöm az ideiglenes fájlokat és kiürítem a lomtárat. Csináljam?",
        "aiActionPrimaryBtn": "Automatikus tisztítás",
        "aiActionSecondaryBtn": "Ne tisztítsd automatikusan",
        "aiActionSuccess": "A tárhelyed kitisztítva.",
        "aiActionFailed": "Valami hiba történt. Próbáld meg később, vagy csináld meg manuálisan.",
        "hey": "Szia",
        "topicStartMessage": "milyen informatikai problémában segíthetek ma?",
        "commonItIssues": "Gyakori informatikai problémák",
        "newChat": "Új chat",
        "open": "Megnyitás",
        "close": "Bezárás",
        "recentChats": "Legutóbbi chatek",
        "ask": "Kérdezz",
        "internet": "Internet",
        "askEon": "Kérdezd az E.ON-t",
        "askInternet": "Kérdezd az internetet",
        "askFollowUpQuestion": "Tegyél fel követő kérdést",
        "resolveIssue": "A visszajelzésed beküldése után tudunk továbblépni a támogatással",
        "resolveIssueAfterFeedback": "Sajnálom, nem tudtam megoldani a problémád. Miben segíthetek még?",
        "differentiator": "vagy",
        "incident": "Szolgáltatási jegy létrehozása",
        "creatingIncident": "Incidens létrehozása",
        "liveAgent": "Csevegés egy ügyintézővel",
        "requestCallbackBtn": "Visszahívás kérése",
        "ticketDescription": "Jegyleírás a legutóbbi beszélgetés alapján",
        "createIncident": "Incidens létrehozása",
        "confirmCreateIncident": "Erősítsd meg az incidens létrehozását",
        "editCreateIncident": "Incidens szerkesztése és létrehozása",
        "ticketSuccessMsg": "Sikeresen létrehoztuk az incidenst. Jegyszám: ",
        "ticketErrorMsg": "Valami hiba történt. Próbáld meg később.",
        "chatBotTitle": "Használd a MyHelp Segítséget kérdésekhez, támogatáshoz és hasznos infókhoz belső és külső forrásokból.",
        "duplicateError": "Ez a kérdés már elhangzott, kérlek, tegyél fel egy másikat",
        "content": "Tartalom",
        "tone": "Hangnem",
        "information": "Információ",
        "complete": "Teljes",
        "other": "Egyéb",
        "irelevantContent": "Nem releváns tartalom",
        "lackOfDetail": "Kevés részlet",
        "incorrectInformation": "Helytelen információ",
        "copyLink": "Link másolása",
        "openLink": "Link megnyitása",
        "internetSearchContent": "Kérdezz bármit az E.ON GPT alapján",
        "assignmentGroupForTicket": "eon-uk-gsd",
        "copy": "Másolás",
        "share": "Megosztás",
        "copiedMsg": "Sikeresen másolva",
        "copyLinkMsg": "Link másolása",
        "sharableLink": "Megosztható link",
        "uploadImage": "Tölts fel képet és tegyél fel kérdést",
        "liveAgentChat": {
            "connectWithLiveAgent": "Kapcsolat a Szolgáltatási Pulttal",
            "connectingWithLiveAgent": "Kapcsolódás a Szolgáltatási Pulttal",
            "connectingHint": "A chatdoboz alatti linkre kattintva visszaválthatsz a Segítségre",
            "agentLeftMsg": "Köszi, hogy felvetted a kapcsolatot az E.ON-nal",
            "switchToAssistance": "Kilépés a chatből és vissza a Segítségre",
            "typeMessageHint": "Írd be az üzeneted ide...",
            "disconnectingMsg": "Kilépés a chatből és vissza a Segítségre",
            "continue": "Folytatás",
            "exitChat": "Kilépés a chatből",
            "chatSessionEndPrompt": "A chatszekció automatikusan véget ér <timer>"
        },
        "requestCallback": {
            "languageConfirmation": "A MyHelp Assistance azt észlelte, hogy az alapértelmezett nyelved: „<language>”. Erősítsd meg, hogy szeretnél beszélni egy ügynökkel, vagy módosítsd lent a kívánt nyelvet és ügynöktípust.",
            "channelsText": "Visszahívás kérése",
            "languageText": "Beszélt nyelv",
            "channelLabel": "Válaszd ki a csatornát",
            "phoneLabel": "Hívj ezen",
            "languageLabel": "Válaszd ki a nyelvet",
            "tryAgain": "Próbáld újra",
            "technicalIssue": "Technikai gond miatt nem tudtuk intézni a visszahívást. Próbáld meg újra.",
            "newNumber": "Új szám",
            "availableMobileNumbers": "Elérhető mobilszámok",
            "chosenNumber": "Ezen a számon hívj",
            "phoneError": "Adj meg egy érvényes telefonszámot",
            "referenceNumber": "Referenciaszám",
            "tooltip": {
                "confirmBtn": "Erősítsd meg a visszahívási kérelmet",
                "resetBtn": "Űrlap visszaállítása: törli a választásokat és újrakezdheted",
                "cancelBtn": "Visszahívás törlése"
            },
            "addNewNumber": "új szám"
        },
        "quickActions": {
            "heading": "my IT support",
            "actions": {
                "createIncident": "Jegy létrehozása",
                "chatWithServiceDesk": "Élő chat indítása",
                "requestCallback": "Visszahívás kérése",
                "ongoingConversation": "Igen, ez az utolsó beszélgetésem része.",
                "newConversation": "Nem. Egy új problémában kérek segítséget",
                "confirmAndCreateTicket": "Erősítsd meg a jegy létrehozását",
                "cancelTicketCreation": "Jegylétrehozás törlése",
                "confirmChatWithServiceDesk": "Erősítsd meg a kapcsolatfelvételt a Szolgáltatási Pulttal",
                "cancelChatWithServiceDesk": "Chat törlése a Szolgáltatási Pulttal",
                "cancelRequestCallback": "Visszahíváskérés törlése",
                "confirmRequestCallback": "Erősítsd meg a kapcsolatfelvételt: <channel> csatornán, a <phone> számon, my IT support ügynökkel, <language> nyelven"
            },
            "state": {
                "whatsTheIssue": "Mi a probléma, amit meg szeretnél oldani?",
                "lastConversation": "Biztos, hogy a probléma része volt az utolsó beszélgetésednek?",
                "createIncidentLabel": "Épp incidensjegy létrehozására készülsz",
                "cancelAck": "Felírva. Segíthetek még valamiben?",
                "chatWithServiceDeskLabel": "Kapcsolatfelvétel a Szolgáltatási Pult ügynökével",
                "createTicketLabel": "Jegylétrehozás megerősítése",
                "cancelTicketLabel": "Jegylétrehozás törlése",
                "creatingIncidentTicket": "Incidensjegy létrehozása",
                "ticketAttachment": "Kérlek, csatolj egy képernyőképet a hibáról vagy a problémáról.",
                "ticketAttachmentTooltipInstruction": "Nyomd meg a Windows logó gombot + Print Screen, vagy használd a Kivágó eszközt egy képkivágáshoz.",
                "ticketAttachmentTooltipWarning": "A kép mérete legyen 5 MB alatt",
                "ticketAttachmentLabel": "Képernyőkép csatolása",
                "ticketAttachmentTitle": "Csatolt képernyőkép a jegyhez",
                "ticketAttachmentError": "Nem sikerült csatolni a kiválasztott fájlt. Győződj meg róla, hogy jpg vagy png, és 5 MB-nál kisebb.",
                "ticketAttachmentErrorAction": "Próbáld újra",
                "ticketDescription": "Jegyleírás",
                "ticketNonITWarning": "A Segítség nem talált olyan kulcsszavakat, amelyek alapján IT-problémának azonosíthatnánk.",
                "ticketNonITWarningQuestion": "Szeretnél incidensjegyet létrehozni a Szolgáltatási Pultnál a beszélgetés alapján?",
                "ticketNonITWarningRecommendationLabel": "Ajánlás:",
                "ticketNonITWarningRecommendationText": "ha a problémád nem szoftverhez vagy hardverhez kapcsolódik, próbáld meg újrafogalmazni a keresést, vagy tegyél fel egy követő kérdést lent",
                "connectWithServiceDeskLabel": "Kapcsolatfelvétel megerősítése a Szolgáltatási Pulttal",
                "requestCallbackLabel": "Visszahívás kérése",
                "requestCallbackInQueuePhone": "A visszahívási kérelmet elküldtük. Körülbelül 5 percen belül felhívunk a <strong><phone></strong> számon. Várakozás közben nyugodtan használj más appokat.",
                "requestCallbackInQueueTeams": "A visszahívási kérelmet elküldtük. Körülbelül 5 percen belül felvesszük veled a kapcsolatot a <strong>Microsoft Teams</strong>-en. Várakozás közben nyugodtan használj más appokat.",
                "requestCallbackFailed": "Technikai gond miatt nem sikerült a visszahívás. Próbáld meg újra.",
                "requestCallbackPromptAnswer": "Visszahívási kérelmet készülsz indítani a my IT support felé",
                "requestCallbackConfirmLabel": "Visszahívási kérelem megerősítése"
            },
            "tooltips": {
                "createIncident": "Segít megoldani egy IT-problémát, és ha kell, létrehoz egy incidenst a Szolgáltatási Pultnál",
                "chatWithServiceDesk": "Segít megoldani egy IT-problémát, és ha kell, chaten összeköt a Szolgáltatási Pulttal",
                "requestCallback": "Visszahívás kérése a Szolgáltatási Pulttól"
            }
        },
        "askTooltip": {
            "eon": "Vállalatspecifikus infók belső forrásokból",
            "internet": "Infók belső és külső forrásokból, pl. E.ON GPT"
        },
        "jiraIntegration": {
            "viewInJira": "Megnyitás a Jira-ban",
            "responseHeading": "Itt a Jira-jegyek összefoglalója:",
            "responseSubheading": "A top 15 rekord megjelenítése",
            "noResponse": "Úgy tűnik, most nincs elérhető JIRA-jegy a kérésedre.",
            "supportedQuestionMsg": "Szia! Bocsi, nem teljesen értettem a kérdésed. Fogalmazd meg újra, kérlek. Addig is mutatok pár mintakérdést:"
        },
        "intune": {
            "selectDevice": "Válasszon eszközt",
            "changeBrowserHomePage": "Böngésző kezdőlapjának módosítása",
            "fixWillBeApplied": "A javítás ezen a rendszeren kerül alkalmazásra",
            "confirm": "Megerősítés",
            "fixThis": "Javítás",
            "enterDeviceName": "Adja meg az eszköz nevét",
            "selectOrEnterDevice": "Kérjük, válasszon egy eszközt, vagy adja meg az eszköz nevét.",
            "actionFailed": "Művelet sikertelen.",
            "working": "Folyamatban...",
            "fixOnThis": "Alkalmazás ezen az eszközön",
            "deviceLabel": "Eszköz",
            "lastActive": "Utoljára aktív",
            "today": "Ma",
            "yesterday": "Tegnap",
            "daysAgo": "napja",
            "deviceTypeLaptop": "Laptop",
            "deviceTypeDesktop": "Asztali számítógép",
            "deviceTypeVirtualMachine": "Virtuális gép",
            "deviceTypeUnknown": "Eszköz",
            "homepageBrowserChange": {
                "syncInstructions": "A módosítás most kerül alkalmazásra az eszközén. Ez körülbelül 90 percet vehet igénybe. Ha szeretné felgyorsítani a folyamatot, kezdeményezhet manuális szinkronizálást a Company Portalból:\n1. Nyissa meg a Company Portal alkalmazást\n2. A bal alsó sarokban kattintson a Settings elemre a fogaskerék ikon mellett.\n3. Ezután kattintson a kék \"Synchronize\" gombra, és várja meg, amíg a szinkronizálás befejeződik.",
                "changeHomepageInstructions": "1. Kattintson a jobb felső sarokban lévő három pontra (...).\n2. Válassza a „Beállítások” lehetőséget.\n3. A bal oldali menüben válassza a „Start, kezdőlap és új lap” menüpontot.\n4. Az „Indításkor” résznél győződjön meg arról, hogy az „Egyéni webhelyek megnyitása” lehetőség ki van választva / be van jelölve.\n5. Ezután kattintson a „Webhely hozzáadása” gombra.\n6. Adja meg annak a webhelynek a címét, amelyet új kezdőlapként szeretne beállítani a Microsoft Edge-ben (például: https://compass.eon.com/).\n7. Kattintson a „Hozzáadás” gombra.\n\nHa el szeretne távolítani egy oldalt a Kezdőlap listából, kattintson az oldal melletti három pontra (...), majd az „Eltávolítás” lehetőségre.",
                "policyDescription": "Szervezete jelenleg eszközszabályzatokon keresztül kezeli a böngésző kezdőlap-beállításait. A kezdőlap módosításának engedélyezéséhez először azonosítanunk kell, melyik eszköznek kell megkapnia a szabályzatfrissítést.",
                "deviceSelectedForPolicy": "kiválasztva a kezdőlap-szabályzat feloldásához",
                "stepsForEdge": "Lépések a kezdőlap módosításához a Microsoft Edge böngészőben",
                "whatsNextTitle": "Mi történik ezután?",
                "whatsNextSubmitted": "A testreszabható kezdőlap engedélyezésére vonatkozó kérelem elküldésre került az eszköz szabályzati várólistájára. ",
                "whatsNextSyncTime": "<strong>90 perc</strong> átlagos szinkronizálási idő szükséges a háttérben történő szabályzatfrissítéshez. ",
                "whatsNextReturn": "Kérjük, 90 perc elteltével térjen vissza a böngésző beállításaihoz, és hajtsa végre az alábbi lépéseket. ",
                "homepageEnabled": "Mostantól megváltoztathatja a böngésző kezdőlap beállításait. Kérjük, vegye figyelembe, hogy a változtatás nem biztos, hogy azonnal érvénybe lép. Várjon körülbelül 30 percet, amíg a szinkronizálás megtörténik, majd zárja be és nyissa meg újra az Edge böngészőt.",
                "homepageAlreadyEnabled": "Az eszközén már engedélyezve van a kezdőlap módosítása. Menjen a böngésző beállításaihoz, és próbálja újra.",
                "homepageEnableFailed": "Jelenleg nem tudtam engedélyezni a kezdőlap módosítását. Kérjük, próbálja meg később.",
                "homepageRemoved": "Az eszköz eltávolítva a kezdőlap házirend csoportból."
            }
        },
        "nexthinkIntegration": {
            "failureMsg": "Hoppá! Valami hiba történt. Próbáld meg később. Ha továbbra is fennáll, indíts egy problémát a Gyors műveletek közül.",
            "assistanceTask": "Segítség feladat",
            "myActions": "Saját műveletek",
            "itReportTitle": "Itt egy pillanatkép a rendszerek energiahatékonyságáról",
            "days": "nap",
            "device": "Eszköz",
            "sinceRestarted": "újraindítás óta",
            "deviceRestartRecommendation": "Javasolt az azonnali újraindítás",
            "deviceInCompliance": "Az eszközöd megfelel az előírásoknak",
            "energyConsumed": "Fogyasztott energia az elmúlt 7 napban",
            "coEmitted": "Kibocsátott CO2 az elmúlt 7 napban",
            "cacheActionMsg": "Indítsd újra a böngésződ, hogy életbe lépjenek a változások.",
            "diskClean": {
                "primaryBtn": "Igen, tisztítsd meg a lemezem most",
                "secondaryBtn": "Ne tisztítsd most",
                "successMsg": "A lemezed megtisztítva",
                "successMsgOnList": "A lemezed megtisztítva",
                "failureMsg": "Most nem tudjuk megtisztítani a lemezed",
                "progressMsg": "Tárhely tisztítása folyamatban",
                "disclaimer": "Fontos: nem nyúlunk a személyes vagy munkával kapcsolatos adataidhoz. Amíg a tisztítás fut a háttérben, nyugodtan használd tovább a Segítséget.",
                "acknowledgeQuery": "El tudom végezni a lemeztisztítást az Ön számára. A lemeztisztítás során a rendszerben lévő felesleges fájlok, gyorsítótárak vagy régi naplók kerülnek eltávolításra. A folytatáshoz kattintson az alábbi gombra."
            },
            "chromeCache": {
                "primaryBtn": "Igen, töröld a Chrome cache-t most",
                "secondaryBtn": "Ne töröld most a Chrome cache-t",
                "successMsg": "A Chrome cache törölve. Indítsd újra a böngészőt, hogy érvényesüljenek a változások.",
                "successMsgOnList": "A Chrome cache törölve",
                "failureMsg": "Most nem tudjuk törölni a Chrome cache-t",
                "progressMsg": "Chrome cache törlése folyamatban",
                "disclaimer": "Fontos: nem nyúlunk a személyes vagy munkával kapcsolatos adataidhoz. Amíg a tisztítás fut a háttérben, nyugodtan használd a Segítséget.",
                "acknowledgeQuery": "Segítek törölni a böngésző gyorsítótárát. A folytatáshoz kattintson az alábbi gombra."
            },
            "edgeCache": {
                "primaryBtn": "Igen, töröld az Edge cache-t most",
                "secondaryBtn": "Ne töröld most az Edge cache-t",
                "successMsg": "Az Edge cache törölve. Indítsd újra a böngészőt, hogy érvényesüljenek a változások.",
                "successMsgOnList": "Az Edge cache törölve",
                "failureMsg": "Most nem tudjuk törölni az Edge cache-t",
                "progressMsg": "Edge cache törlése folyamatban",
                "disclaimer": "Fontos: nem nyúlunk a személyes vagy munkával kapcsolatos adataidhoz. Amíg a tisztítás fut a háttérben, nyugodtan használd a Segítséget.",
                "acknowledgeQuery": "Segítek törölni az Edge böngésző gyorsítótárát. A folytatáshoz kattintson az alábbi gombra."
            },
            "empowerPlugin": {
                "progressMsg": "Az Empower bővítményre vonatkozó kérés folyamatban van",
                "successMsgOnList": "Az Empower bővítményre vonatkozó kérés befejeződött",
                "failureMsg": "Az Empower bővítményre vonatkozó kérést nem sikerült befejezni"
            },
            "empowerApp": {
                "primaryBtn": "Igen, javítsd most",
                "secondaryBtn": "Ne javítsd most",
                "successMsg": "Automatikus javítás sikeresen befejezve",
                "successMsgOnList": "Automatikus javítás sikeresen befejezve",
                "failureMsg": "Most nem tudjuk megjavítani az Empower plugint",
                "progressMsg": "Automatikus javítás folyamatban",
                "disclaimer": "Újratelepítjük az Empower plugint; kérlek, zárj be minden O365 alkalmazást, mielőtt továbblépsz.",
                "acknowledgeQuery": "Segíthetek az Empower bővítménnyel kapcsolatos problémákban. Kattintson az alábbi gombra az Empower bővítmény javításához."
            },
            "teamsCache": {
                "primaryBtn": "Igen, töröld a Teams cache-t most",
                "secondaryBtn": "Ne töröld most a Teams cache-t",
                "successMsg": "A Teams cache törölve. Megnyithatod a Teams-et, és újrakonfigurálhatod az esetlegesen alaphelyzetbe állított beállításokat.",
                "successMsgOnList": "A Teams cache törölve",
                "failureMsg": "Most nem tudjuk törölni a Teams cache-t",
                "progressMsg": "Teams cache törlése folyamatban",
                "disclaimer": "Fontos: nem nyúlunk a személyes vagy munkával kapcsolatos adataidhoz. Amíg a tisztítás fut a háttérben, nyugodtan használd a Segítséget.",
                "acknowledgeQuery": "Segítek törölni a Teams gyorsítótárát. A folytatáshoz kattintson az alábbi gombra."
            },
            "teamsReinstall": {
                "primaryBtn": "Igen, telepítsd újra a Teams-et",
                "secondaryBtn": "Ne telepítsd újra a Teams-et",
                "successMsg": "A Teams alkalmazás újratelepítése befejezve",
                "successMsgOnList": "A Teams alkalmazás újratelepítése befejezve",
                "failureMsg": "A Teams újratelepítése nem fejezhető be",
                "progressMsg": "Teams újratelepítése folyamatban",
                "disclaimer": "Ez letölti és újratelepíti a Teams-et, és újra is indítja. Mentsd el a munkád, mielőtt továbblépsz.",
                "acknowledgeQuery": "A Microsoft Teams alkalmazás újratelepítése megoldhatja a problémát. A folytatáshoz kattintson az alábbi gombra."
            },
            "outlookOst": {
                "primaryBtn": "Igen, javítsd az Outlookot",
                "secondaryBtn": "Ne javítsd az Outlookot",
                "successMsg": "Az Outlook-profil újralétrehozva",
                "successMsgOnList": "Az Outlook-profil újralétrehozva",
                "failureMsg": "Az Outlook-profil nem hozható létre újra",
                "progressMsg": "Outlook-profil újralétrehozása",
                "disclaimer": "Ez helyben újralétrehozza az Outlook-profilodat, és elindítja az e-mailek letöltését az Exchange-ből. Győződj meg róla, hogy van elég sávszélesség és tárhely.",
                "acknowledgeQuery": "Ezt okozhatják kapcsolati problémák vagy elavult beállítások. Segítek a hibaelhárításban, és abban, hogy az Outlook ismét szinkronban legyen."
            },
            "repairOfficeApps": {
                "primaryBtn": "Igen, javítsd az Office alkalmazásokat",
                "secondaryBtn": "Ne javítsd az Office alkalmazásokat",
                "successMsg": "Az Office alkalmazások javítva",
                "successMsgOnList": "Az Office alkalmazások javítva",
                "failureMsg": "Az Office alkalmazásokat most nem tudjuk megjavítani",
                "progressMsg": "Az Office alkalmazások újratelepítése folyamatban",
                "disclaimer": "Ez újratelepíti és megpróbálja megjavítani az Office appokat. Ments el minden nem mentett munkát, mielőtt továbblépsz.",
                "acknowledgeQuery": "Ezt okozhatja sérült telepítés vagy kompatibilitási probléma. Segítek az Office alkalmazások javításában, hogy az alkalmazások zökkenőmentesen megnyíljanak."
            },
            "intuneSync": {
                "primaryBtn": "Igen, indítsd el az Intune szinkronizálást",
                "secondaryBtn": "Ne indítsd el a szinkronizálást",
                "successMsg": "Az Intune szinkronizálás befejezve",
                "successMsgOnList": "Az Intune szinkronizálás befejezve",
                "failureMsg": "Az Intune szinkronizálás nem indítható el",
                "progressMsg": "Intune szinkronizálás folyamatban",
                "disclaimer": "Ez csak az Intune szinkronizálási szolgáltatásokat indítja újra; nem telepíti újra és nem javítja az Intune-t (Vállalati portál).",
                "acknowledgeQuery": "Segítek frissíteni az eszköz állapotát és szinkronizálni az Intune-nal, hogy megfeleljen az előírásoknak, naprakész legyen, és a legújabb házirendeket alkalmazza."
            },
            "teamsAddin": {
                "primaryBtn": "Igen, engedélyezd a MS Teams bővítményt",
                "secondaryBtn": "Ne engedélyezd a bővítményt",
                "successMsg": "A MS Teams bővítmény javítása kész",
                "successMsgOnList": "A MS Teams bővítmény javítása befejezve",
                "failureMsg": "A MS Teams bővítmény most nem engedélyezhető",
                "progressMsg": "A MS Teams bővítmény engedélyezése folyamatban",
                "disclaimer": "A MS Teams bővítmény javításához újra kell indítani az Outlookot. Mentsd el a munkád, mielőtt továbblépsz.",
                "acknowledgeQuery": "Segítek visszaállítani a Teams bővítményt az Outlookban, hogy ismét tudjon értekezleteket ütemezni. A folytatáshoz kattintson az alábbi gombra."
            },
            "windowsUpdate": {
                "primaryBtn": "Igen, nézz rá a frissítésekre",
                "secondaryBtn": "Nem, ne ellenőrizd",
                "successMsg": "A Windows-frissítés elindítva",
                "successMsgOnList": "A Windows frissítés elindítva",
                "failureMsg": "Nem sikerült elindítani a Windows-frissítést",
                "progressMsg": "Frissítések ellenőrzése",
                "disclaimer": "Ez ellenőrzi és letölti a frissítéseket a Microsofttól. Győződj meg róla, hogy megfelelő hálózathoz csatlakozol, hogy letölthesd a frissítéseket.",
                "acknowledgeQuery": "Segítek megoldani a Windows frissítési és megfelelőségi problémákat az eszközén. A folytatáshoz kattintson az alábbi gombra"
            },
            "smartSolution": {
                "systemName": "Rendszer neve",
                "primaryBtn": "Gyors ellenőrzés futtatása",
                "secondaryBtn": "Nem most",
                "askToRunHealthCheck": "Szeretnéd, hogy a Segítség lefuttasson egy gyors állapotellenőrzést?",
                "healthCheckApiRunning": "Állapotellenőrzés fut és elemzés",
                "healthCheckApiFail": "Nem sikerült lekérni az állapotellenőrzési infókat, próbáld újra",
                "healthCheckApiSuccess": "Átnéztem a rendszert. Ezeket találtam problémásnak:",
                "systemCheckMsg": "Rendszerellenőrzés folyamatban",
                "systemCheckMessages": {
                    "recentlyStarted": "A rendszer naprakész, és nemrég indult újra",
                    "appsHealthy": "Minden alkalmazás telepítése rendben van",
                    "driveSpace": "Bőséges szabad hely van a rendszermeghajtón",
                    "noCrashes": "Az utóbbi időben nem észleltünk alkalmazás összeomlást"
                },
                "healthCheckNoIssue": "Átnéztem a rendszert. <b>Minden rendben működik.</b>",
                "recommendedActionHeading": "Ajánlott lépések",
                "askForElaboration": "Kérlek, írd le részletesebben a gondot, vagy tölts fel képernyőképet róla.",
                "remindForSystemCheck": "Oké, szólj, amikor szeretnéd lefuttatni a rendszerellenőrzést.",
                "recommendedFixesHeading": "Ajánlott javítások",
                "recommendedActionInfo": "Válaszd ki (vagy vedd ki) a javasolt javításokat, ha szeretnéd",
                "noRecommendedAction": "Nincs ajánlott lépés",
                "initiateActionsButton": "Javítás indítása",
                "selectedActionsProgress": "A kiválasztott műveletek futnak.",
                "selectedActionsProgressNote": "Nyugodtan használd a Segítséget, amíg a művelet fut. A lépés felkerült a Segítség feladatlistára, ott követheted. Szólunk, ha kész.",
                "selectedActionsCompleted": "A kiválasztott műveletek sikeresen befejeződtek.",
                "selectedActionsFailed": "A kiválasztott műveletek nem sikerültek. Nézd meg a Segítség feladatkártyát a részletekért.",
                "selectedActionsPartiallyCompleted": "A kiválasztott műveletek részben készültek el. Nézd meg a Segítség feladatkártyát a részletekért.",
                "myActionDone": "Jelöld késznek",
                "manualActionDisclaimer": "A folyamatban automatikus és manuális lépések is vannak. Kérlek, végezd el a kért lépéseket, amikor megjelennek.",
                "manualActionNotification": "A javítás befejezéséhez kérlek, csináld meg manuálisan a további lépéseket a 'Saját műveletek' alatt.",
                "deviceSelectionHeading": "Látom, több rendszert használsz. Ha máson szeretnéd futtatni a következő műveletet, válassz alább.",
                "deviceSelectionLabel": "Válaszd ki a rendszert a Nexthink művelethez",
                "alerts": {
                    "successTitle": "Feladat befejezve!",
                    "successMessage": "A kiválasztott műveletek sikeresen befejeződtek.",
                    "errorTitle": "Feladat sikertelen!",
                    "errorMessage": "Hiba történt a kiválasztott művelet végrehajtása közben.",
                    "partialTitle": "Feladat részben befejezve",
                    "partialMessage": "A kiválasztott műveletek részben elkészültek. Nézd meg a Segítség feladatkártyát a részletekért."
                },
                "reportAndAction": {
                    "systemCrashes": {
                        "message": "Az elmúlt 7 napban <n> kékhalál történt az eszközödön.",
                        "action": "Vedd fel a kapcsolatot a GSD-vel további segítségért",
                        "actionInfo": "(Nincs automatikus lépés) vedd fel a kapcsolatot a GSD-vel további segítségért"
                    },
                    "edgeCrashes": {
                        "message": "Az elmúlt 7 napban <n> Edge-böngésző összeomlást találtunk. Megpróbáljuk ezt orvosolni egy szkript futtatásával az eszközödön.",
                        "action": "Edge böngésző cache törlése",
                        "actionInfo": "Ez törli az Edge böngésző cache-t, és nem módosít személyes fájlokat"
                    },
                    "chromeCrashes": {
                        "message": "Az elmúlt 7 napban <n> Chrome böngésző összeomlást találtunk. Megpróbáljuk orvosolni ezt egy szkript futtatásával az eszközödön.",
                        "action": "Chrome böngésző cache törlése",
                        "actionInfo": "Ez törli a Chrome cache-t, és nem módosít meglévő fájlokat."
                    },
                    "ZScalarStatus": {
                        "message": "A Zscaler szolgáltatás néhány problémába ütközött az eszközödön. Megpróbáljuk orvosolni ezt egy szkript futtatásával az eszközödön.",
                        "action": "Zscaler szolgáltatás újraindítása",
                        "actionInfo": "Ez a művelet újraindítja a hálózati kapcsolatot. Nincs hatása a nyitott programokra."
                    },
                    "ZScalarState": {
                        "message": "A Zscaler szolgáltatás néhány problémába ütközött az eszközödön. Megpróbáljuk orvosolni ezt egy szkript futtatásával az eszközödön.",
                        "action": "Zscaler visszaállítása",
                        "actionInfo": "Ez a művelet újraindítja a hálózati kapcsolatot. Nincs hatása a nyitott programokra."
                    },
                    "driveFreeSpace": {
                        "message": "Az eszközödön csak <n> GB szabad hely maradt. Az optimális teljesítmény érdekében javasoljuk a szabad hely növelését a Windows számára egy szkript futtatásával az eszközödön.",
                        "action": "Lemez tisztítása",
                        "actionInfo": "Csak az ideiglenes fájlokat és a lomtárat tisztítjuk"
                    },
                    "daysSinceFullBoot": {
                        "message": "Az eszközöd nem indult újra teljesen az elmúlt <n> napban. Ez eltér a normál leállítási eljárástól. Javasoljuk a teljes újraindítást (Start | Leállítás | Újraindítás).",
                        "action": "Indítsd újra az eszközt minél előbb.",
                        "actionInfo": ""
                    },
                    "teamsCrashes": {
                        "message": "Az elmúlt 7 napban <n> Microsoft Teamshez köthető összeomlást találtunk. Megpróbáljuk orvosolni: lefuttatunk egy szkriptet a Teams cache törlésére.",
                        "action": "Teams cache törlése",
                        "actionInfo": "Ez a művelet törli a MS Teams cache-t és újraindítja azt. Előfordulhat, hogy a piszkozat / el nem küldött Teams üzenetek is törlődnek."
                    },
                    "teamsPluginDisabled": {
                        "message": "A Microsoft Outlookban észleltük, hogy a Microsoft Teams bővítmény le van tiltva. Ez problémákat okoz a két alkalmazás között. Megpróbáljuk orvosolni egy szkript futtatásával a beállítások újrakonfigurálására.",
                        "action": "Outlook bővítmények beállítása",
                        "actionInfo": "Ez a művelet engedélyezi a Teams bővítményt az Outlookban és újraindítja az alkalmazást."
                    },
                    "outlookOstStatus": {
                        "message": "Az Outlook profilod túlnőtt az optimális méreten, ez gondokat okozhat a postafiókoddal. Megpróbáljuk orvosolni: futtatunk egy szkriptet a fájl újrakreálására.",
                        "action": "Outlook OST fájl javítása",
                        "actionInfo": "Ez átnevezi az Outlook OST fájlt és újraindítja az alkalmazást. Törölheti a piszkozat e-maileket."
                    },
                    "lastOsUpdate": {
                        "message": "Úgy látjuk, hogy a Windows Update szolgáltatás nem fut megfelelően, és az eszközöd utoljára <n> napja frissült. Javasoljuk a teljes újraindítást (Start | Leállítás | Újraindítás), ez segíthet pár beállítás visszaállításában.",
                        "action": "Indítsd újra az eszközt minél előbb",
                        "actionInfo": ""
                    }
                },
                "acknowledgeQuery": "Segítek az eszközével kapcsolatos probléma hibaelhárításában. Nézzük meg és oldjuk meg a problémát."
            },
            "declineScriptMsg": "Nem szeretném futtatni a Nexthink szkriptet, kérlek, javasolj más megoldást",
            "timezone": {
                "primaryBtn": "Igen, folytasd",
                "secondaryBtn": "Nem, ne frissítsd",
                "successMsg": "Az időzóna észlelése automatikusra állítva",
                "successMsgOnList": "Az időzóna észlelése automatikusra lett állítva",
                "failureMsg": "Az időzóna beállítását nem tudtuk frissíteni",
                "progressMsg": "Időzóna-beállítások frissítése",
                "disclaimer": "Ez automatikusra állítja az időzóna-szolgáltatást, így a Windows a helyed alapján frissíti az asztali órát.",
                "acknowledgeQuery": "Segítek helyrehozni a rendszeridő és az időzóna beállításait. A legtöbb idővel kapcsolatos probléma – például az óra elcsúszása, hibás időbélyegek, sikertelen hitelesítési kódok vagy téves értekezletidők – helytelen időzóna vagy letiltott automatikus szinkronizálás miatt fordul elő. Kattintson az alábbi gombra, hogy automatikusan felismerjük és kijavítsuk a Windows idő- és időzóna-konfigurációját."
            },
            "chooseBrowser": "Válassz böngészőt a gyorsítótár törléséhez",
            "outlookAutoComplete": {
                "primaryBtn": "Igen, töröld az Outlook gyorsítótárát",
                "secondaryBtn": "Nem, ne töröld az Outlook gyorsítótárát",
                "successMsg": "Az Outlook automatikus kiegészítés gyorsítótára törölve",
                "successMsgOnList": "Az Outlook automatikus kiegészítés gyorsítótára törölve",
                "failureMsg": "Az Outlook automatikus kiegészítés gyorsítótárát most nem tudjuk törölni",
                "progressMsg": "Outlook automatikus kiegészítés gyorsítótárának törlése",
                "disclaimer": "Figyelem: az automatikus kiegészítés gyorsítótár törlése eltávolítja a mentett e-mail cím javaslatokat. Ez a művelet nem visszavonható.",
                "acknowledgeQuery": "Segítek kijavítani az Outlook automatikus kiegészítésének gyorsítótárát. Kattintson az alábbi gombra az Outlook automatikus kiegészítésének automatikus javításához."
            },
            "restartZscalar": {
                "primaryBtn": "Igen, folytasd",
                "secondaryBtn": "Nem, ne indítsd újra a Zscalert",
                "successMsg": "Zscaler újraindítva",
                "successMsgOnList": "Zscaler újraindítva",
                "failureMsg": "A Zscalert most nem tudjuk újraindítani",
                "progressMsg": "Zscaler szolgáltatások újraindítása",
                "disclaimer": "A Zscaler újraindítása rövid időre megszakíthatja az internetet és a munkaalkalmazásokat. Ez általában kevesebb mint egy perc.",
                "acknowledgeQuery": "Segítek megoldani a Zscaler szolgáltatásokkal kapcsolatos problémát. Kattintson az alábbi gombra a Zscaler-problémák megoldásához."
            },
            "onedrive": {
                "primaryBtn": "Igen, javítsd a OneDrive-ot",
                "secondaryBtn": "Nem, ne futtasd a OneDrive-javítást",
                "successMsg": "A OneDrive-javítás kész",
                "successMsgOnList": "A OneDrive-javítás befejeződött",
                "failureMsg": "A OneDrive javítást nem sikerült befejezni",
                "progressMsg": "OneDrive-javítás fut",
                "disclaimer": "A OneDrive javítása a helyi fájlok felhőbe szinkronizálását eredményezi, és megzavarhatja az egyéni OneDrive-szinkronizálásokat.",
                "acknowledgeQuery": "Segítek megoldani a OneDrive problémáit. Kattintson az alábbi gombra a OneDrive-problémák megoldásához."
            },
            "smartcard": {
                "primaryBtn": "Igen, távolítsd el a Smart cardot",
                "secondaryBtn": "Nem, ne távolítsd el a Smart cardot",
                "successMsg": "A Microsoft Smart card eltávolítva",
                "successMsgOnList": "A Microsoft Smart card el lett távolítva",
                "failureMsg": "Nem sikerült eltávolítani a Microsoft Smart cardot",
                "progressMsg": "A Microsoft Smart card eltávolítása",
                "disclaimer": "Ez a művelet akár 1 percig is tarthat.",
                "acknowledgeQuery": "Segítek megoldani a Microsoft Smart Card Reader problémáit. Kattintson az alábbi gombra a Smart Card problémák megoldásához."
            },
            "errorFetchingReport": "Bocsi, nem sikerült lekérni a jelentést. Próbáld meg később.",
            "automatedFix": "Automatikus javítás",
            "automatedFixConsent": "Meg tudom oldani ezt a problémát az eszközödön. Elindítsam az automatikus javítást?",
            "primaryButton": "Igen, indítsd el a javítást",
            "teamViewerReset": {
                "primaryBtn": "Igen, folytasd",
                "secondaryBtn": "Nem, ne állítsd vissza",
                "successMsg": "A Teamviewer szolgáltatásai vissza lettek állítva",
                "successMsgOnList": "A Teamviewer szolgáltatásai vissza lettek állítva",
                "failureMsg": "Nem sikerült visszaállítani a Teamviewer szolgáltatásait",
                "progressMsg": "Folyamatban van a Teamviewer szolgáltatásainak újraindítása",
                "disclaimer": "Ez a művelet visszaállítja a Teamviewer szolgáltatásait és újraindítja a Teamviewer alkalmazást. Kérjük, a folytatás előtt győződjön meg róla, hogy a munkáját elmentette.",
                "acknowledgeQuery": "Segítek a Teamviewer visszaállításában. A folytatáshoz kattintson az alábbi gombra."
            },
            "zoomUninstall": {
                "primaryBtn": "Igen, távolítsd el a Zoomot",
                "secondaryBtn": "Nem, ne távolítsd el",
                "successMsg": "A Zoom eltávolítva",
                "successMsgOnList": "A Zoom eltávolítva",
                "failureMsg": "Nem sikerült eltávolítani a Zoomot",
                "progressMsg": "A Zoom eltávolítása folyamatban van",
                "disclaimer": "Ez eltávolítja a Zoomot az eszközödről, és egyben törli a Zoom összes beállítását is.",
                "acknowledgeQuery": "Segítek eltávolítani a Zoomot. A folytatáshoz kattintson az alábbi gombra."
            },
            "webexUninstall": {
                "primaryBtn": "Igen, távolítsd el a Webexet",
                "secondaryBtn": "Nem, ne távolítsd el",
                "successMsg": "A Webex eltávolítva",
                "successMsgOnList": "A Webex eltávolítva",
                "failureMsg": "Nem sikerült eltávolítani a Webexet",
                "progressMsg": "A Webex eltávolítása folyamatban van",
                "disclaimer": "Ez eltávolítja a Cisco Webexet az eszközödről, és egyben törli a Cisco Webex összes beállítását is.",
                "acknowledgeQuery": "Segítek eltávolítani a Cisco Webexet. A folytatáshoz kattintson az alábbi gombra."
            },
            "recommendedAction": "Ajánlott művelet",
            "noKbArticleFound": "Nem találtunk manuális lépéseket vagy tudáscikkeket ehhez a problémához. Van azonban egy ajánlott művelet, amely megoldhatja:"
        },
        "sessions": {
            "title": "Legutóbbi chatek",
            "clearAll": "Összes chat törlése",
            "deleteMessage": "Munkamenet törlése",
            "footer": "Megjegyzés: az utolsó 30 nap beszélgetései megmaradnak.",
            "recentChatTitle": "Csevegési előzmények (30 nap)",
            "noRecentChat": "Nincsenek legutóbbi chatek",
            "startNewChat": "Új chat indítása",
            "learnMore": "Tudj meg többet.",
            "learnMoreTooltip": "A MyHelp megőrzési szabályzata szerint az utolsó 30 nap beszélgetései elérhetők, hacsak nem törlöd őket a törlés vagy az összes törlése gombbal."
        },
        "search": "E.ON Search",
        "feedbackMsg": "Köszi a visszajelzést! Nagyon értékeljük, hogy segítesz jobbá tenni a szolgáltatásainkat.",
        "contactNumberPlaceholder": "Telefonszám országkóddal",
        "incidentDetailsLabel": "Esemény összefoglalása",
        "contactNumberLabel": "Add meg a preferált telefonszámod",
        "incError": "Adj meg érvényes incidensrészleteket",
        "contactError": "Adj meg érvényes telefonszámot",
        "searchAsk": "Írd le a problémádat, pl. jelszó-visszaállítás",
        "teamsInsights": {
            "specifyDateTime": "Add meg, mikor történt (dátum és idő), és melyik értekezletet vagy csevegést érintette.",
            "date": "Dátum",
            "getMeetings": "Értekezletek lekérése",
            "cancel": "Mégse",
            "noMeetings": "Ehhez a dátumhoz nem találtunk értekezletet.",
            "meetingInstruction": "Válaszd ki azt az értekezletet/hívást, amelynél minőségi gondok voltak.",
            "identifyIssue": "Probléma azonosítása",
            "issueDetectionCompleted": "A problémaazonosítás kész.",
            "detectingIssues": "Értekezletproblémák vizsgálata",
            "recommendedActions": "Javasolt lépések:",
            "noInsightsFound": "Ehhez a híváshoz nem találtunk elemzést.",
            "meetingList": "Értekezletek/hívások",
            "fetchingMeetings": "A mai Teams-értekezletek lekérése folyamatban",
            "windowsOnly": "Az értekezlet-elemzések csak Windows eszközről csatlakozott hívásokhoz érhetők el.",
            "confirmCreateIncident": "Szeretnél incidensjegyet létrehozni az értekezleten észlelt problémához?",
            "getMeetingsCancelMsg": "Az értekezletek lekérésére vonatkozó kérés törölve.",
            "identifyIssueCancelMsg": "A probléma azonosítására vonatkozó kérés törölve.",
            "createIncidentCancelMsg": "Az incidens létrehozására vonatkozó kérés törölve.",
            "noIssueFoundInstruction": "Több teljesítménymutatót is átvizsgáltunk az Ön oldalán, és minden rendben lévőnek tűnik. Ha problémákat tapasztalt a hívás/értekezlet során, az ok nagy valószínűséggel a többi résztvevő oldalán keresendő.",
            "report": {
                "lowWifiRootCause": "A hívás alatt gyenge volt a Wi‑Fi jel, ami minőségi gondokat okozhatott. Ha otthonról/távolról csatlakoztál, ellenőrizd, milyen messze vagy a routertől.",
                "networkIssueRootCauseManaged": "Úgy tűnik, ma egy E.ON irodában vagy, és hálózati gondok befolyásolták az értekezlet minőségét. Fontold meg egy incidensjegy nyitását, és írd bele a tartózkodási helyed.",
                "networkIssueRootCauseUnmanaged": "Úgy tűnik, ma nem E.ON irodában vagy, és hálózati gondok befolyásolták az értekezlet minőségét. Ellenőrizd a helyi Wi‑Fi/internetkapcsolat stabilitását. Ha lehet, használj kábeles kapcsolatot, vagy menj közelebb a Wi‑Fi routerhez.",
                "noDataRootCause": "Ehhez a paraméterhez nem állt rendelkezésre elemzés a hívás alatt.",
                "noIssueRootCause": "Ehhez a paraméterhez nem észleltünk problémát.",
                "noIssueRecommendation": "Nincs teendő.",
                "failed": "Sikertelen",
                "checking": "Ellenőrzés",
                "okay": "Rendben",
                "na": "N/A",
                "audio": "Hang",
                "video": "Videó",
                "deviceCpuUsage": {
                    "displayName": "Eszköz CPU-használata",
                    "rootCause": "Magas CPU-terhelést észleltünk az eszközödön a hívás közben. Nézd meg, futottak-e háttérfolyamatok vagy appok, és ha lehet, ne tarts túl sok alkalmazást nyitva, hogy a gép jobban a megbeszélésre fókuszálhasson.",
                    "recommendation": "A CPU-terhelés csökkentéséhez zárd be a felesleges háttérappokat a hívás alatt."
                },
                "deviceMemoryUsedPct": {
                    "displayName": "Eszköz memóriahasználata",
                    "rootCause": "Magas memóriahasználatot észleltünk az eszközödön a hívás közben. Nézd meg, futottak-e háttérfolyamatok vagy appok, és ha lehet, ne tarts túl sok alkalmazást nyitva, hogy a gép jobban a megbeszélésre fókuszálhasson.",
                    "recommendation": "A memóriahasználat csökkentéséhez zárd be a felesleges háttérappokat a hívás alatt."
                },
                "wifiSignalQuality": {
                    "displayName": "Wi‑Fi-jelminőség",
                    "recommendation": "Menj közelebb a routerhez, vagy válts erősebb Wi‑Fi-hálózatra."
                },
                "audioJitter": {
                    "displayName": "Hang jitter"
                },
                "audioJBDelay": {
                    "displayName": "Hang JB késleltetés"
                },
                "audioRecvLossRate": {
                    "displayName": "Hang vételi veszteség aránya"
                },
                "audioRtt": {
                    "displayName": "Hang késleltetés (RTT)"
                },
                "videoRtt": {
                    "displayName": "Videó késleltetés (RTT)"
                },
                "videoRecvLossRate": {
                    "displayName": "Videó vételi veszteség aránya"
                },
                "wifiChannelCenterFrequencyInKilohertz": {
                    "displayName": "Wi‑Fi csatorna középfrekvencia (kHz)",
                    "rootCause": "2,4 GHz-es Wi‑Fi-t használsz, ami gyakran rontja a hívásminőséget. Érdemes 5 GHz-es vagy magasabb sávra váltani.",
                    "recommendation": "A jobb hívásminőséghez válts 5 GHz-es (vagy magasabb) Wi‑Fi sávra."
                },
                "wifiSsidChangeDetected": {
                    "displayName": "Hálózatváltás észlelve",
                    "rootCauseManaged": "Azt észleltük, hogy Wi-Fi- vagy hozzáférési pont váltás történt a hívása során egy E.ON irodában. Ez a hívás megszakadását okozhatta. Ha nem mozgott az eszközével, kérjük, rögzítse ezt incidens jegyként.",
                    "rootCauseUnmanaged": "Azt észleltük, hogy nem egy E.ON helyszínről csatlakozott. Kérjük, ellenőrizze, hogy a Wi-Fi kapcsolata stabil-e, mivel a hálózati problémák befolyásolhatják az értekezlet minőségét.",
                    "rootCause": "A hívás közben hálózatváltást észleltünk, ez megszakíthatta a hívást.",
                    "recommendation": "A teljes hívás alatt tartsd az eszközt stabil Wi‑Fi hálózaton."
                }
            }
        },
        "rightSidebar": {
            "panelLabel": "Folyamatban lévő tevékenységek",
            "closePanel": "Tevékenységpanel bezárása",
            "openPanel": "Tevékenységpanel megnyitása",
            "emptyState": "Még nincs folyamatban lévő tevékenység.",
            "ticketPrefix": "Jegy",
            "openedAtPrefix": "Megnyitva:",
            "showTicketDetails": "Jegy áttekintése",
            "defaultTaskLabel": "Nexthink művelet"
        }
    },
    "snow": {
        "welcomeNote": "Kérlek, nézd meg alább a nyitott incidensek, rendelések és IT-eszközök áttekintését.",
        "tabName": {
            "incidents": "Incidensek",
            "orders": "Rendelések",
            "itResources": "IT-erőforrások",
            "incidentsTable": {
                "noData": "Nincs adat",
                "btnText": "Nyiss új incidenst",
                "ongoing": "Folyamatban",
                "closed": "Lezárt",
                "headlineText": "Incidensek"
            },
            "orderTable": {
                "number": "Szám",
                "catItem": "Kategóriaelem",
                "approvalSet": "Jóváhagyási készlet",
                "state": "Állapot",
                "dueDate": "Határidő",
                "createdOn": "Létrehozva",
                "noData": "Nincs adat",
                "btnText": "Rendelj IT-szolgáltatásokat",
                "headlineText": "Rendelések",
                "tooltipText": "IT-eszközök, szoftverek, licencek vagy szolgáltatások igénylése és kezelése"
            },
            "itResourcesTable": {
                "modelCategory": "Modellkategória",
                "model": "Modell",
                "computerName": "Számítógép neve",
                "serialNumber": "Sorozatszám",
                "serviceValue1": "Szolgáltatás érték 1",
                "serviceValue2": "Szolgáltatás érték 2",
                "noData": "Nincs adat",
                "btnText": "Nyiss jegyet az IT-erőforrásokhoz",
                "headlineText": "Saját eszközök"
            }
        }
    },
    "moveTabAndTiles": {
        "tabNames": "Fül",
        "favourite": "Kedvenc",
        "categorizeTiles": "Saját irányítópult",
        "enterTabName": "Add meg a fül nevét",
        "tabNameError": "Adj meg egy egyedi fülnevet, 2 és 20 karakter között!",
        "tabInputLabel": "Fül neve",
        "addTabButton": "Fül hozzáadása",
        "personalizeTab": "Fülek testreszabása",
        "personalizeTiles": "Csempék testreszabása",
        "addTab": "Új fül hozzáadása",
        "removeTabConfrim": "Biztosan eltávolítod a fület",
        "with": " a",
        "cardIn": "csempékkel?",
        "actionUndone": "Ezt nem lehet visszavonni.",
        "categorizeTilesTitle": "Fülek átnevezése, törlése és csempék áthelyezése a füleken belül",
        "addTabTitle": "Új fül hozzáadása. Maximum 4 fület hozhatsz létre.",
        "organiseTilesTitle": "Csempék átrendezése"
    },
    "dataTable": {
        "pagingData": "Elem/oldal",
        "itemString": "elemek",
        "ofString": "/"
    },
    "tourData": {
        "userActions": {
            "back": "Vissza",
            "close": "Bezár",
            "last": "Kész",
            "next": "Tovább",
            "step": "Lépés",
            "of": "ból",
            "open": "Párbeszédablak megnyitása",
            "skip": "Kihagy",
            "start_tour": "Indítsd el a túrát",
            "tour_info": "Szeretnéd, ha megmutatnánk a fő funkciókat egy gyors, vezetett túrán? Csak 1-2 perc az egész..."
        },
        "tile": {
            "step1": "Használd a MyHelp-et, hogy megtaláld a tipikus munkafeladatokhoz szükséges alkalmazásokat, vagy kérdezz bármit az E.ON erőforrásairól, például IT, projektek, képzések, vállalati szabályzatok és még sok más.",
            "step2": "Tudj meg többet a MyHelp-ről és a funkcióiról, találsz válaszokat a gyakori kérdésekre, és hasznos tippeket-trükköket a felhasználói dokumentációban.",
            "step3": "Itt bármikor átállíthatod a kedvenc nyelved.",
            "step4": "Itt kijelentkezhetsz.",
            "step5": "Kezdj új beszélgetést, nézd meg a legutóbbi csevegéseidet, hogy ott folytasd, ahol abbahagytad, vagy indíts E.ON-keresést a nagyító megnyomásával",
            "step6": "A személyre szabott irányítópultod segít rendszerezni és elérni a kedvenc, munkához szükséges alkalmazásaidat. Keress egy alkalmazást, és add hozzá a plusz ikonnal. Hozz létre új füleket, és rendezd át az alkalmazásokat, ahogy szükséged van rá."
        },
        "tab": {
            "step1": "Itt adhatsz hozzá új fület.",
            "step2": "Itt állíthatod be a csempék sorrendjét.",
            "step3": "Itt átnevezheted és rendezheted a füleket."
        },
        "chat": {
            "step1": "Írd le az IT-problémádat",
            "navigation": "Eligazodás a MyHelpben",
            "headerNavigation_description": "A fejléc navigációjával megnyithatod az Ask MyHelp, a Dashboard és más elérhető oldalakat.",
            "sidebarNavigation_description": "Az oldalsó navigációval oldalakat nyithatsz meg, új beszélgetést indíthatsz vagy visszatérhetsz a korábbi beszélgetésekhez.",
            "support_description": "Nyisd meg a My IT-Supportot, hogy segítséget kapj az informatikai problémádhoz és megtaláld a megfelelő támogatást.",
            "step1_description": "Lépésről lépésre kapsz segítséget a gyakori IT-gondokhoz – az E.ON IT-támogatási tudásbázisai alapján. Ha kell, a MyHelp a megfelelő IT-támogatási csatornához irányít.",
            "step2": "Fedezd fel a tipikus IT-ügyeket",
            "step2_description": "Itt olyan gyakori IT-ügyeket látsz, ahol a MyHelp lépésről lépésre segít.",
            "step3": "Érd el gyorsabban az alkalmazásaidat",
            "step3_description": "Használd a Dashboardot, mentsd el a gyakran használt alkalmazásokat, és rakd össze a saját munkatered.",
            "step4": "Indíts új csevegést, vagy folytasd a korábbi beszélgetéseket",
            "step4_description": "Használd az oldalsávot új beszélgetés indításához, vagy hogy gyorsan visszatérj a korábbi csevegésekhez."
        }
    },
    "allApps": {
        "addAppsBtn": "Appok hozzáadása",
        "addAppsInfo": "A kezdéshez kattints az „Appok hozzáadása” lehetőségre",
        "addAppsTitle": "Rakd össze a saját, személyre szabott munkatered",
        "addAppsDesc": "Add hozzá a leggyakrabban használt appjaidat, hogy gyorsabban elérd a mindennap használt eszközöket",
        "customTileButton": "Egyéni kártya hozzáadása",
        "CustomTileHeading": "Egyéni kártya",
        "customTileTitleLabel": "Kártya címe",
        "customTileSubTitle": "Kártya leírása",
        "customTileUrlLabel": "Kártya linkje",
        "createCardBtn": "Kártya létrehozása",
        "modalHeading": "Appok az E.ON-on",
        "modalDesc": "Keress rá vagy válassz ki egy appot, és add a kezdőlaphoz",
        "titleRequired": "Add meg a kártya címét",
        "linkRequired": "Add meg a kártya linkjét",
        "searchPlaceholder": "App keresése"
    },
    "onboardingPortal": {
        "onboardAppBtn": "Bevezető portál",
        "heading": "Bevezető portál",
        "subHeading": "Nézd át az alkalmazásaidat, vezess be újakat, és oszd meg a kezelési hozzáférést a csapatoddal.",
        "modules": {
            "home": "Kezdőlap",
            "apps": "Alkalmazások",
            "appsLabel": "Alkalmazások",
            "qna": "Q&A",
            "qnaLabel": "Kérdés és válasz",
            "review": "Ellenőrzés",
            "reviewLabel": "Ellenőrzés",
            "onboardApp": "Új alkalmazás bevezetése",
            "manageApp": "Alkalmazások kezelése",
            "defaultApps": "Alapértelmezett alkalmazások",
            "onboardQnA": "QnA bevezetése",
            "manageQnA": "QnA kezelése",
            "reviewDashboard": "Ellenőri irányítópult",
            "reviewApps": "Alkalmazások ellenőrzése",
            "reviewQnA": "Kérdések és válaszok ellenőrzése"
        },
        "appOnboardingForm": {
            "formHeading": "Új alkalmazás bevezetése",
            "successAlert": "Sikeresen bevezetted az alkalmazást!",
            "appTitleLabel": "Alkalmazás neve",
            "appTitleTooltip": "Az app neve, ami megjelenik",
            "appTitlePlaceholder": "Az alkalmazás megjelenő neve",
            "appTitleError": "Add meg az alkalmazás nevét",
            "appSubTitleLabel": "Alkalmazás alcíme",
            "appSubTitleTooltip": "Az alkalmazás alcíme",
            "appSubTitlePlaceholder": "Az alkalmazás alcíme",
            "appSubTitleError": "Add meg az alkalmazás alcímét",
            "appUrlLabel": "Alkalmazás URL-je",
            "appUrlTooltip": "Az alkalmazás célcíme",
            "appUrlPlaceholder": "Az alkalmazás célcíme",
            "appUrlError": "Add meg az alkalmazás URL-jét",
            "appKeywordsLabel": "synKeywords (vesszővel elválasztva)",
            "appKeywordsTooltip": "Add meg azokat a szinonimákat, amiket a felhasználók az alkalmazás megtalálásához használhatnak, és vesszővel válaszd el őket",
            "appKeywordsPlaceholder": "Add meg azokat a szinonimákat, amiket a felhasználók az alkalmazás megtalálásához használhatnak, és vesszővel válaszd el őket",
            "appKeywordsError": "Add meg a kulcsszavakat",
            "appCompaniesAllowedLabel": "Engedélyezett vállalatok",
            "appCompaniesAllowedTooltip": "Azoknak a vállalatoknak a listája, ahol ez az app engedélyezett. Ha mindenkinek elérhető, hagyd üresen.",
            "appCompaniesAllowedInfoMessage": "Azoknak a vállalatoknak a listája, ahol ez az app engedélyezett. Ha mindenkinek elérhető, hagyd üresen.",
            "appCompaniesAllowedOtherLabel": "Egyéb engedélyezett vállalatok",
            "appCompaniesAllowedOtherPlaceholder": "Add meg az egyéb engedélyezett vállalatokat",
            "appCompaniesRestrictedLabel": "Korlátozott vállalatok",
            "appCompaniesRestrictedTooltip": "Azoknak a vállalatoknak a listája, ahol ez az app NEM engedélyezett. Ha nincs korlátozás, hagyd üresen.",
            "appCompaniesRestrictedInfoMessage": "Azoknak a vállalatoknak a listája, ahol ez az app NEM engedélyezett. Ha nincs korlátozás, hagyd üresen.",
            "appCompaniesRestrictedOtherLabel": "Egyéb korlátozott vállalatok",
            "appCompaniesRestrictedOtherPlaceholder": "Add meg az egyéb korlátozott vállalatokat",
            "appTooltipLabel": "Eszköztipp (add meg az összes nyelvet, ha különböző neveket kell megjeleníteni)",
            "appTooltipTooltip": "Add meg az összes nyelvet, ha különböző neveket kell megjeleníteni, pl. EN- This is My HR tooltip, DE- Dies ist mein HR-Tooltip",
            "appTooltipPlaceholder": "Add meg az összes nyelvet, ha különböző neveket kell megjeleníteni, pl. EN- This is My HR tooltip, DE- Dies ist mein HR-Tooltip",
            "appTooltipError": "Add meg az eszköztippet",
            "appIconLabel": "Töltsd fel az alkalmazás ikonját",
            "appIconTooltip": "Töltsd fel az alkalmazás ikonját",
            "previewAppBtn": "Alkalmazás előnézete",
            "cancelBtn": "Mégse",
            "closeBtn": "Bezárás",
            "submitAppBtn": "Alkalmazás beküldése",
            "updateAppBtn": "Alkalmazás frissítése",
            "editAppBtn": "Alkalmazás szerkesztése",
            "appTitlePreview": "Cím",
            "appSubTitlePreview": "Alcím",
            "appUrlPreview": "URL",
            "appKeywordsPreview": "Kulcsszavak",
            "appCompaniesAllowedPreview": "Engedélyezett vállalatok",
            "appCompaniesRestrictedPreview": "Korlátozott vállalatok",
            "appTooltipPreview": "Eszköztipp",
            "message": "Miután beküldted az alkalmazást, Függőben státuszt kap, és egy meghatározott felülvizsgálati életcikluson megy át — haladva a Függőben → Jóváhagyott (felülvizsgálat/tesztelés alatt) → QA-ban (formálisan jóváhagyva és ellenőrzés alatt) → Termelésben (élő és látható a végfelhasználók számára a MyHelp-en), vagy Elutasítottá válhat, ha nem felel meg a kritériumoknak; ebben az esetben az érdekelt fél szerkesztheti és újra beküldheti."
        },
        "qnaOnboardingForm": {
            "formHeading": "Új QnA bevezetése",
            "successAlert": "Sikeresen bevezetted a QnA-t!",
            "qnaQuestionLabel": "Kérdés",
            "qnaQuestionTooltip": "Add meg a QnA elem kérdését",
            "qnaQuestionPlaceholder": "Add meg a kérdést",
            "qnaQuestionError": "Add meg a kérdést",
            "qnaAnswerLabel": "Válasz",
            "qnaAnswerTooltip": "Add meg a QnA elem válaszát",
            "qnaAnswerPlaceholder": "Add meg a választ",
            "qnaAnswerError": "Add meg a választ",
            "qnaCategoryLabel": "Kategória",
            "qnaCategoryTooltip": "Válaszd ki a QnA elem kategóriáját",
            "qnaCategoryPlaceholder": "Válaszd ki a QnA elem kategóriáját",
            "qnaCategoryError": "Válassz kategóriát",
            "qnaCategoryOtherLabel": "Egyéb kategória",
            "qnaCategoryOtherPlaceholder": "Adj meg egyéni kategóriát",
            "qnaCompaniesAllowedLabel": "Engedélyezett vállalatok",
            "qnaCompaniesAllowedTooltip": "Azoknak a vállalatoknak a listája, ahol ez a QnA engedélyezett. Ha mindenkinek elérhető, hagyd üresen.",
            "qnaCompaniesAllowedInfoMessage": "Azoknak a vállalatoknak a listája, ahol ez a QnA engedélyezett. Ha mindenkinek elérhető, hagyd üresen.",
            "qnaCompaniesAllowedOtherLabel": "Egyéb engedélyezett vállalatok",
            "qnaCompaniesAllowedOtherPlaceholder": "Add meg az egyéb engedélyezett vállalatokat",
            "qnaCompaniesRestrictedLabel": "Korlátozott vállalatok",
            "qnaCompaniesRestrictedTooltip": "Azoknak a vállalatoknak a listája, ahol ez a QnA NEM engedélyezett. Ha nincs korlátozás, hagyd üresen.",
            "qnaCompaniesRestrictedInfoMessage": "Azoknak a vállalatoknak a listája, ahol ez a QnA NEM engedélyezett. Ha nincs korlátozás, hagyd üresen.",
            "qnaCompaniesRestrictedOtherLabel": "Egyéb korlátozott vállalatok",
            "qnaCompaniesRestrictedOtherPlaceholder": "Add meg az egyéb korlátozott vállalatokat",
            "previewQnABtn": "QnA előnézete",
            "cancelBtn": "Mégse",
            "submitQnABtn": "QnA beküldése",
            "updateQnABtn": "QnA frissítése",
            "editQnABtn": "QnA szerkesztése",
            "addNewQnABtn": "+ QnA hozzáadása",
            "qnaQuestionPreview": "Kérdés",
            "qnaAnswerPreview": "Válasz",
            "qnaCompaniesAllowedPreview": "Engedélyezett vállalatok",
            "qnaCompaniesRestrictedPreview": "Korlátozott vállalatok",
            "message": "Miután beküldted a Q&A-bejegyzést, Függőben státuszt kap, és egy meghatározott felülvizsgálati életcikluson megy át — haladva a Függőben → Jóváhagyott (felülvizsgálat/tesztelés alatt) → QA-ban (formálisan jóváhagyva és ellenőrzés alatt) → Termelésben (élő és látható a végfelhasználók számára a MyHelp-en), vagy Elutasítottá válhat, ha nem felel meg a kritériumoknak; ebben az esetben az érdekelt fél szerkesztheti és újra beküldheti."
        },
        "manageBtn": "Kezelés",
        "refreshBtn": "Frissítés",
        "exportBtn": "Exportálás",
        "exportCsvBtn": "CSV",
        "exportExcelBtn": "Excel",
        "exportAppsCsvBtn": "Alkalmazások exportálása CSV-ként",
        "exportAppsExcelBtn": "Alkalmazások exportálása Excel-ként",
        "exportQnACsvBtn": "QnA exportálása CSV-ként",
        "exportQnAExcelBtn": "QnA exportálása Excel-ként",
        "approveBtn": "Jóváhagyás",
        "rejectBtn": "Elutasítás",
        "toQABtn": "Átrakás QA-ba",
        "toProdBtn": "Átrakás élesbe",
        "editBtn": "Szerkesztés",
        "viewBtn": "Megtekintés",
        "closeBtn": "Bezárás",
        "dashboard": {
            "appsTitle": "Elérhető alkalmazások",
            "appsText": "Azok az alkalmazások, amikhez tulajdonosként vagy csapatmegosztással hozzáférsz.",
            "qnaTitle": "Kérdések és válaszok",
            "qnaText": "Azok a kérdések és válaszok, amikhez tulajdonosként vagy csapatmegosztással hozzáférsz."
        },
        "modalLabel": {
            "reviewAppTitle": "Alkalmazás felülvizsgálata az integrációhoz",
            "reviewQnATitle": "Q&A felülvizsgálata az integrációhoz",
            "owner": "Tulajdonos",
            "createdOn": "Létrehozva",
            "status": "Állapot",
            "url": "URL",
            "tooltip": "Eszköztipp",
            "companiesAllowed": "Engedélyezett vállalatok",
            "companiesRestricted": "Korlátozott vállalatok",
            "keywords": "Kulcsszavak",
            "reviewerComments": "Felülvizsgálati megjegyzések",
            "category": "Kategória",
            "question": "Kérdés",
            "answer": "Válasz",
            "mail": "E-mail"
        },
        "statusLabel": {
            "pending": "Függőben",
            "approved": "Jóváhagyva",
            "rejected": "Elutasítva",
            "onhold": "Szüneteltetve",
            "unknown": "Ismeretlen",
            "all": "Összes",
            "inQA": "QA-ban",
            "inProd": "Élesben"
        },
        "activityLabel": {
            "allowed": "Engedélyezett",
            "restricted": "Korlátozott"
        },
        "tableHeaders": {
            "status": "Állapot",
            "action": "Művelet",
            "icon": "Ikon",
            "title": "Cím",
            "subTitle": "Alcím",
            "question": "Kérdés",
            "answer": "Válasz",
            "category": "Kategória",
            "owner": "Tulajdonos",
            "description": "Leírás",
            "apps": "Alkalmazások",
            "qna": "Kérdés és válasz",
            "defaultApps": "Alapértelmezett alkalmazások",
            "defaultAppsActivity": "Alapértelmezett alkalmazások módosításai",
            "search": "Keresés",
            "selectCompany": "Válassz céget",
            "otherCompany": "Másik cég neve",
            "selectAll": "Mind kiválasztása",
            "company": "Cég",
            "update": "Frissítés",
            "comments": "Megjegyzések"
        },
        "noData": {
            "dashboardEmpty": "Még nincs hozzáadott alkalmazás vagy Q&A",
            "dashboardAppsEmpty": "Még nincs hozzáadott alkalmazás",
            "dashboardQnAEmpty": "Még nincs hozzáadott Q&A",
            "reviewDashboardEmpty": "Nincs ellenőrzésre beküldött alkalmazás vagy Q&A.",
            "reviewAppsEmpty": "Nincs ellenőrzésre beküldött alkalmazás.",
            "reviewQnAEmpty": "Nincs ellenőrzésre beküldött Q&A."
        },
        "manageApp": {
            "heading": "Alkalmazások kezelése",
            "subHeading": "Csak azok az alkalmazások jelennek meg, amelyeknek te vagy a tulajdonosa, vagy amelyekhez hozzáférést kaptál."
        },
        "manageQnA": {
            "heading": "QnA kezelése",
            "subHeading": "Csak azok a QnA-k jelennek meg, amelyeknek te vagy a tulajdonosa, vagy amelyekhez hozzáférést kaptál."
        },
        "defaultApps": {
            "heading": "Alapértelmezett alkalmazások",
            "subHeading": "Itt azok az alkalmazások vannak, amelyek alapértelmezetten minden felhasználónak elérhetők. A megjelenített alkalmazásokat be- vagy kikapcsolással módosíthatod.",
            "searchPlaceholder": "Keress alkalmazásokat"
        },
        "reviewDashboard": {
            "heading": "Ellenőrzési irányítópult",
            "subHeading": "Nézd át a függőben lévő alkalmazás-bevezetési igényeket, és hagyd jóvá vagy utasítsd el őket. A gyors ellenőrzések segítenek abban, hogy mindenkinek releváns és hasznos alkalmazásgyűjteményt fenntartsunk."
        },
        "reviewApps": {
            "heading": "Alkalmazások ellenőrzése",
            "subHeading": "Nézd át a függőben lévő alkalmazás-bevezetési igényeket, és hagyd jóvá vagy utasítsd el őket. A gyors ellenőrzések segítenek abban, hogy mindenkinek releváns és hasznos alkalmazásgyűjteményt fenntartsunk."
        },
        "reviewQnA": {
            "heading": "Kérdés és válasz ellenőrzése",
            "subHeading": "Nézd át a függőben lévő QnA-bevezetési igényeket, és hagyd jóvá vagy utasítsd el őket. A gyors ellenőrzések segítenek abban, hogy mindenkinek releváns és hasznos QnA-gyűjteményt fenntartsunk."
        },
        "reviewQueue": {
            "heading": "Felülvizsgálati sor",
            "subHeading": "Nézd meg, és hagyd jóvá vagy utasítsd el a függőben lévő alkalmazás-feltöltési kéréseket. A gyors felülvizsgálatod segít fenntartani egy mindenkinek releváns és hasznos alkalmazásgyűjteményt."
        },
        "activityLog": {
            "heading": "Tevékenységi napló"
        },
        "quickActions": {
            "title": "Gyors műveletek",
            "onboardNewApp": "Új alkalmazás bevezetése",
            "manageApps": "Alkalmazások kezelése",
            "defaultApps": "Alapértelmezett alkalmazások",
            "onboardNewQnA": "Új kérdés és válasz bevezetése",
            "manageQnA": "Kérdések és válaszok kezelése",
            "reviewerDashboard": "Ellenőri irányítópult",
            "reviewApps": "Bevezetett alkalmazások ellenőrzése",
            "reviewQnA": "Bevezetett kérdések és válaszok ellenőrzése"
        }
    },
    "sourceSelector": {
        "title": "Válassz forrást",
        "allSources": "Összes forrás",
        "allSourcesDesc": "Keress az összes belső E.ON infóforrásban",
        "eonKnowledgeBase": "E.ON tudásbázis",
        "eonKnowledgeBaseDesc": "Érd el az általános vállalati tudást",
        "eonMyItOrder": "E.ON My IT rendeléseid",
        "eonMyItOrderDesc": "Kezeld és kövesd az IT-szolgáltatási rendeléseidet",
        "eonItKnowledgeBase": "E.ON IT tudásbázis",
        "eonItKnowledgeBaseDesc": "Keress IT-s infókat és megoldásokat",
        "myGenius": "My Genius",
        "myGeniusDesc": "Fedezz fel belső kurzusokat és anyagokat",
        "confluenceAll": "Confluence (összes)",
        "confluenceAllDesc": "Keress közösen szerkesztett doksikat",
        "sharepointAll": "SharePoint (összes)",
        "sharepointAllDesc": "Keress közös fájlokat és erőforrásokat",
        "eonApps": "E.ON appok",
        "eonAppsDesc": "Fedezz fel és használj vállalati appokat",
        "hrPolicies": "HR-szabályok",
        "hrPoliciesDesc": "Érd el a HR-szabályokat és útmutatókat",
        "compass": "Compass",
        "compassDesc": "Fedezd fel az E.ON intranetet",
        "back": "Vissza",
        "search": "Keress...",
        "noMatches": "Nincs találat"
    },
    "ailoader": {
        "thinking": "Gondolkodom...",
        "reading": "Olvasom a forrásokat...",
        "processing": "Feldolgozom...",
        "analysing": "Elemzem az eredményeket...",
        "preparing": "Összerakom a választ...",
        "working": "Dolgozom a válaszon – ez eltarthat egy darabig."
    },
    "compassScopeSelector": {
        "title": "Válassz üzleti egységet",
        "iconLabel": "Keresési kör",
        "localSearch": "Helyi keresés",
        "compassWideSearch": "Keresés az egész Compassban",
        "resetToCompassWide": "Állítsd vissza az egész Compassban való keresésre",
        "switchToLocal": "Válts helyi keresésre",
        "localDescription": "Keress a cégen belül és a nyilvános bejegyzésekben",
        "compassWideDescription": "Keress az összes üzleti egységben"
    },
    "errorMessages": {
        "azureAiContentViolation": "A választ kiszűrtük, mert a lekérdezésed beindította az Azure OpenAI tartalomkezelési szabályait. Kérlek, módosítsd a lekérdezést, és próbáld újra."
    }
}